import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import api from '../../../../api';
import Modal from '../../../../components/common/Modal';
import ConfirmationModal from '../../../../components/common/ConfirmationModal';
import Alert from '../../../../components/Alert/Alert';
import { ArrowLeft } from 'lucide-react';
// import SendToClientButtonWithWorkflowModal from '../SendToClientButtonWithWorkflowModal';
import { sendProposalEmail, getProposalEmailTemplates, checkEmailSettings } from '../../api/proposalEmailApi';
import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import ImageModule from 'docxtemplater-image';
// Import helper functions for template formatting
import { formatTemplateData } from './templateFormatters';
// Import Proposal Stage API
import { getProposalStages } from '../../../ProposalStage/api/proposalStageApi';
// Import AppSelect component
import { AppSelect, FormFieldSelect } from '../../../../components/common/select';
import { GenericView, ActionButtons } from '../../../../components/common/table';
import { ArrowDownToLine } from 'lucide-react';
// Import currency utilities
import { getCurrencySymbol, getCurrencyPrefix } from '../../../../utils/currencyUtils';
// Import file operations utilities
import { getFileIcon, formatFileSize, formatDate, transformFileData } from '../../../../utils/fileOperations';
const DetailProposal = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [proposalData, setProposalData] = useState(null);
    const [loading, setLoading] = useState(true);

    // Helper function to format status descriptions to proper case
    const formatStatusDesc = (status) => {
        if (!status) return status;

        // Convert to string, replace underscores with spaces, convert to lowercase
        return status
            .toString()
            .replace(/_/g, ' ')
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    // Badge color helpers (matching Proposals list page)
    const getStatusBadge = (status) => {
        const colors = {
            'Rejected': 'danger',
            'Draft': 'secondary',
            'Need Approval': 'primary',
            'Revision': 'warning',
            'Approved': 'success',
        };
        return `badge badge-outline text-${colors[status] || 'secondary'}`;
    };

    const getProposalStatusBadge = (status) => {
        const colors = {
            'Draft': 'secondary',
            'Send To Client': 'primary',
            'Send to Client': 'primary',
            'Feedback': 'warning',
            'Accepted': 'success',
            'Rejected': 'danger',
        };
        return `badge badge-outline text-${colors[status] || 'secondary'}`;
    };

    const getProjectStatusBadge = (status) => {
        const colors = {
            'Converted': 'success',
            'Not Converted': 'orange'
        };
        return `badge badge-outline text-${colors[status] || 'secondary'}`;
    };
    // Add state for dynamic investment breakdown
    const [investmentBreakdown, setInvestmentBreakdown] = useState(null);
    const [yearOptionsByServiceItem, setYearOptionsByServiceItem] = useState({});
    const [showBreakdown, setShowBreakdown] = useState(false);
    // Add missing state variables for send to client functionality
    const [sendToClientDisabled, setSendToClientDisabled] = useState(false);
    const [sendToClientLabel, setSendToClientLabel] = useState('Send to Client');
    // Add state untuk modal workflow (sama seperti di EditProposal)
    const [showWorkflowModal, setShowWorkflowModal] = useState(false);
    const [workflowItems, setWorkflowItems] = useState([]);
    const [loadingWorkflow, setLoadingWorkflow] = useState(false);
    // ✅ TAMBAHAN: Add state for workflow note
    const [workflowNote, setWorkflowNote] = useState('');
    const [alert, setAlert] = useState(null);
    const [isProcessingSend, setIsProcessingSend] = useState(false);
    const [isConvertingProject, setIsConvertingProject] = useState(false);
    const [isAcceptingProposal, setIsAcceptingProposal] = useState(false);
    // Workflow validation
    const [showWorkflowValidationModal, setShowWorkflowValidationModal] = useState(false);
    const [serviceItemsWithoutWorkflow, setServiceItemsWithoutWorkflow] = useState([]);
    const [loadingWorkflowValidation, setLoadingWorkflowValidation] = useState(false);
    // Add state untuk filled document
    const [filledDocumentUrl, setFilledDocumentUrl] = useState(null);
    const [loadingDocument, setLoadingDocument] = useState(false);
    const [documentError, setDocumentError] = useState(null);
    const [showDocument, setShowDocument] = useState(false);
    const [activeTab, setActiveTab] = useState('tabs-proposal-item'); // Track active tab
    // Add state for confirmation modals
    const [showSendToClientModal, setShowSendToClientModal] = useState(false);
    const [showConvertToProjectModal, setShowConvertToProjectModal] = useState(false);
    const [showAcceptProposalModal, setShowAcceptProposalModal] = useState(false);
    const [showNpwpValidationModal, setShowNpwpValidationModal] = useState(false);
    const [companyData, setCompanyData] = useState(null);
    const [isValidatingNpwp, setIsValidatingNpwp] = useState(false);
    const [npwpValidationCompanyId, setNpwpValidationCompanyId] = useState(null);
    const [npwpInputValue, setNpwpInputValue] = useState('');
    const [isSavingNpwp, setIsSavingNpwp] = useState(false);
    // Add state for email functionality
    const [emailSettings, setEmailSettings] = useState(null);
    const [emailTemplates, setEmailTemplates] = useState([]);
    const [isSendingEmail, setIsSendingEmail] = useState(false);
    const [emailStatus, setEmailStatus] = useState(null); // Add this for email status
    const [clientEmail, setClientEmail] = useState('');
    const [emailDataLoaded, setEmailDataLoaded] = useState(false); // Add this flag
    const [isLoadingEmailData, setIsLoadingEmailData] = useState(false);
    // Add currency handling like EditProposal
    const [proposalCurrencyCode, setProposalCurrencyCode] = useState('IDR');
    // Add state for proposal stages
    const [proposalStages, setProposalStages] = useState([]);
    const [selectedProposalStage, setSelectedProposalStage] = useState('1'); // Default to id 1
    const [loadingProposalStages, setLoadingProposalStages] = useState(false);
    // Tagging (multi-select below Proposal Stage)
    const [taggingOptions, setTaggingOptions] = useState([]);
    const [selectedTaggingIds, setSelectedTaggingIds] = useState([]);
    const [savedTaggingIds, setSavedTaggingIds] = useState([]);
    const [loadingTaggingOptions, setLoadingTaggingOptions] = useState(false);
    const [savingTagging, setSavingTagging] = useState(false);
    // Lost stage: show confirmation modal to select reason (reasons from API /crm/reason-loss/all)
    const [showLostReasonModal, setShowLostReasonModal] = useState(false);
    const [pendingLostStageId, setPendingLostStageId] = useState(null);
    const [lostReason, setLostReason] = useState('');
    const [reasonLossOptions, setReasonLossOptions] = useState([]);
    const [loadingReasonLoss, setLoadingReasonLoss] = useState(false);
    const [note, setNote] = useState('');
    const [isSubmittingLost, setIsSubmittingLost] = useState(false);
    // Ref to track if default stage has been saved to prevent duplicate saves
    const defaultStageSavedRef = useRef(false);
    // Add state for approval status
    const [approvalStatus, setApprovalStatus] = useState(null);
    const [loadingApprovalStatus, setLoadingApprovalStatus] = useState(false);
    // Add state for file management
    const [files, setFiles] = useState([]);
    const [loadingFiles, setLoadingFiles] = useState(false);
    const [showDeleteFileModal, setShowDeleteFileModal] = useState(false);
    const [fileToDelete, setFileToDelete] = useState(null);
    const [uploadingFile, setUploadingFile] = useState(false);
    // Upload category: which record the new file should be saved against
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [uploadCategory, setUploadCategory] = useState('Proposal');
    const [leadServiceOptions, setLeadServiceOptions] = useState([]);
    const [selectedLeadServiceId, setSelectedLeadServiceId] = useState('');
    // Add state for project status
    const [projectStatus, setProjectStatus] = useState('Not Converted');
    const [leadSector, setLeadSector] = useState('');
    // Add state for lead data and project data
    const [leadData, setLeadData] = useState(null);
    const [projectData, setProjectData] = useState(null);
    const [companyId, setCompanyId] = useState(null); // Store company ID from proposal

    // Reset default stage saved ref when proposal ID changes
    useEffect(() => {
        defaultStageSavedRef.current = false;
    }, [id]);

    // Ensure Bootstrap dropdown is initialized for Actions button (some dropdowns are added after initial Nav init)
    useEffect(() => {
        if (typeof window !== 'undefined' && window.bootstrap && window.bootstrap.Dropdown) {
            const btn = document.getElementById('actions-dropdown-button');
            if (btn) {
                try {
                    // Initialize or get existing instance
                    if (window.bootstrap.Dropdown.getOrCreateInstance) {
                        window.bootstrap.Dropdown.getOrCreateInstance(btn);
                    } else {
                        new window.bootstrap.Dropdown(btn);
                    }
                } catch (err) {
                    // swallow errors — non-critical
                    // console.debug('Dropdown init error', err);
                }
            }
        }
    }, [proposalData]);

    // Controlled Actions dropdown state (fallback if Bootstrap JS doesn't initialize)
    const [actionsOpen, setActionsOpen] = useState(false);
    const actionsRef = useRef(null);
    useEffect(() => {
        const handleDocClick = (e) => {
            if (!actionsRef.current) return;
            if (!actionsRef.current.contains(e.target)) {
                setActionsOpen(false);
            }
        };
        const handleKey = (e) => {
            if (e.key === 'Escape') setActionsOpen(false);
        };
        document.addEventListener('click', handleDocClick);
        document.addEventListener('keydown', handleKey);
        return () => {
            document.removeEventListener('click', handleDocClick);
            document.removeEventListener('keydown', handleKey);
        };
    }, []);

    useEffect(() => {
        // Simulate API call
        const fetchData = async () => {
            try {
                const res = await api.get(`crm/proposals/detail/lead/${id}`);

                // Format status descriptions to proper case
                const fixedData = {
                    ...res.data,
                    statusDesc: formatStatusDesc(res.data.statusDesc),
                    statusApproval: formatStatusDesc(res.data.statusApproval || res.data.statusDesc),
                    statusProposalDesc: formatStatusDesc(res.data.statusProposalDesc)
                };
                setProposalData(fixedData);

                // Set company ID for clickable company name
                // Note: fixedData.client might not have id field, so we'll get it from lead data later
                // For now, don't set companyId from client.id as it might be incorrect

                // Fetch project status from projects table (same method as list page)
                // Use leadId from response if available, otherwise use URL param
                const leadIdToFetch = res.data?.leadId || id;

                if (leadIdToFetch) {
                    try {
                        // Fetch lead data
                        const leadResponse = await api.get(`/crm/leads/${leadIdToFetch}`);
                        setLeadData(leadResponse.data);

                        // Set company ID from lead data
                        if (leadResponse.data?.companyId) {
                            setCompanyId(leadResponse.data.companyId);
                        } else if (leadResponse.data?.company?.id) {
                            setCompanyId(leadResponse.data.company.id);
                        }

                        // Use the same batch endpoint as list page for project status
                        const batchRes = await api.get('/crm/projects/status-by-leads', {
                            params: { leadIds: String(leadIdToFetch) }
                        });

                        // Parse response
                        const list = Array.isArray(batchRes?.data) ? batchRes.data : [];
                        let statusDesc = null;
                        let projectInfo = null;

                        if (list.length > 0) {
                            projectInfo = list[0];
                            statusDesc = projectInfo?.status_desc ?? projectInfo?.statusDesc ?? projectInfo?.status;
                        }
                        // No fallback needed - if batch endpoint returns empty, no project exists

                        // Store project data if available
                        if (projectInfo && projectInfo.projectCode) {
                            // The status-by-leads API already returns projectCode, use it directly
                            setProjectData(projectInfo);
                        } else {
                            setProjectData(null);
                        }

                        // Normalize the status (same logic as list page)
                        if (statusDesc != null) {
                            const val = String(statusDesc).toLowerCase();

                            if (['converted', '1', 'true', 'done', 'closed', 'success'].includes(val)) {
                                setProjectStatus('Converted');
                            } else if (['not converted', '0', 'false', 'open', 'pending', 'draft'].includes(val)) {
                                setProjectStatus('Not Converted');
                            } else {
                                const finalStatus = typeof statusDesc === 'string' ? statusDesc : 'Converted';
                                setProjectStatus(finalStatus);
                            }
                        } else {
                            setProjectStatus('Not Converted');
                        }
                    } catch (projectErr) {
                        setProjectStatus('Not Converted');
                        setLeadData(null);
                        setProjectData(null);
                    }
                }

                // Handle currency like EditProposal - simple approach
                if (res.data) {
                    if (res.data.displayCurrencyId) {
                        try {
                            const currencyRes = await api.get(`crm/currencies/${res.data.displayCurrencyId}`);
                            setProposalCurrencyCode(currencyRes.data.currencyCode || 'IDR');
                        } catch (error) {
                            console.warn('Could not fetch currency for displayCurrencyId:', res.data.displayCurrencyId, error);
                            setProposalCurrencyCode('IDR');
                        }
                    } else {
                        setProposalCurrencyCode('IDR');
                    }
                }

                // ✅ Fetch lead data to get sector information
                // Reuse the same leadIdToFetch variable declared earlier
                if (leadIdToFetch) {
                    try {
                        const leadResponse = await api.get(`/crm/leads/${leadIdToFetch}`);
                        const sector = leadResponse.data?.sector || '';
                        setLeadSector(sector);
                    } catch (leadError) {
                        console.error('Error fetching lead sector:', leadError);
                        setLeadSector('');
                    }
                }

                // Try to fetch investment breakdown from API first
                try {
                    await fetchInvestmentBreakdown(fixedData);
                } catch (error) {
                    // Fallback to local calculation if API fails
                    if (res.data && res.data.proposal_sections) {
                        calculateInvestmentBreakdown(res.data.proposal_sections);
                    }
                }

                // Automatically load document if available
                if (res.data && (res.data.proposalPdfFillPdf || res.data.proposalPdfFill)) {
                    // Wait for proposalData to be set before downloading document
                    setTimeout(() => {
                        downloadAndDisplayFilledDocument();
                    }, 100);
                }
            } catch (error) {
                console.error('Error fetching proposal:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [id]);
    // Function to load proposal stages
    const loadProposalStages = async () => {
        setLoadingProposalStages(true);
        try {
            const response = await getProposalStages();
            // Backend returns array directly, not wrapped in response.data
            const stages = Array.isArray(response) ? response : [];
            setProposalStages(stages);
        } catch (error) {
            console.error('Error loading proposal stages:', error);
            setAlert({ type: 'danger', message: 'Failed to load proposal stages' });
        } finally {
            setLoadingProposalStages(false);
        }
    };
    // Function to load approval status
    const loadApprovalStatus = async () => {
        setLoadingApprovalStatus(true);
        try {
            const response = await api.get(`crm/proposals/${id}/approval-status`);
            setApprovalStatus(response.data);
        } catch (error) {
            console.error('Error loading approval status:', error);
            setApprovalStatus(null);
        } finally {
            setLoadingApprovalStatus(false);
        }
    };
    // Load proposal stages when component mounts
    useEffect(() => {
        loadProposalStages();
    }, []);
    // Load approval status when component mounts
    useEffect(() => {
        loadApprovalStatus();
    }, []);
    // No helper functions needed as they exist in column definitions
    // Transform a getCompanyDocuments() entry (CID1/CID2, Invoice, Payment, etc.) into the shared file-row shape
    const transformCompanyDocument = (doc) => ({
        id: doc.id,
        fileName: doc.documentName || 'Unknown File',
        fileSize: doc.size || 0,
        uploadedBy: doc.sourceCode || doc.source || 'Unknown',
        uploadDate: doc.uploadedDate,
        fileType: doc.mimeType || doc.fileType || 'application/octet-stream',
        description: doc.category || doc.type || '',
        documentType: doc.category || doc.type || 'attachment',
        updatedAt: doc.uploadedDate,
        name: doc.documentName || 'Unknown File',
        size: doc.size || 0,
        uploaded_by: doc.sourceCode || doc.source || 'Unknown',
        upload_date: doc.uploadedDate,
        createdAt: doc.uploadedDate,
        source: doc.source,
        category: doc.category || doc.type || doc.source,
        filePath: doc.filePath
    });
    // Function to load files
    const loadFiles = async () => {
        setLoadingFiles(true);
        try {
            // Get actual proposal ID from lead ID
            const proposalId = await getProposalId(id);
            const endpoint = `crm/proposal-documents/proposal/${proposalId}`;
            const [proposalDocsRes, companyDocsRes] = await Promise.allSettled([
                api.get(endpoint),
                companyId ? api.get(`crm/proposals/company-documents/${companyId}`) : Promise.resolve({ data: [] })
            ]);

            const proposalDocs = proposalDocsRes.status === 'fulfilled' ? (proposalDocsRes.value.data || []) : [];
            const companyDocs = companyDocsRes.status === 'fulfilled' ? (companyDocsRes.value.data || []) : [];

            // Transform the response to match the expected format
            const transformedProposalFiles = proposalDocs.map((doc, index) => ({
                ...transformFileData(doc, index),
                source: 'Proposal',
                category: doc.documentType || 'Proposal Document'
            }));
            // getCompanyDocuments() also includes Proposal Documents - skip those to avoid duplicates,
            // keep only CID1/CID2/Lead/Invoice/Payment sourced entries
            const transformedCompanyFiles = companyDocs
                .filter((doc) => doc.source !== 'Proposal')
                .map((doc) => transformCompanyDocument(doc));

            setFiles([...transformedProposalFiles, ...transformedCompanyFiles]);
        } catch (error) {
            console.error('Error loading files:', error);
            console.error('Error details:', error.response?.data);
            // Show error alert
            setAlert({
                type: 'warning',
                message: 'Failed to load files: ' + (error.response?.data?.message || error.message)
            });
            // Set empty array as fallback
            setFiles([]);
        } finally {
            setLoadingFiles(false);
        }
    };
    // Load files when component mounts, and reload once companyId becomes available
    useEffect(() => {
        loadFiles();
        // eslint-disable-next-line
    }, [companyId]);
    // Load the lead's services once leadData is available, so CID1/CID2/Other uploads
    // know which lead-service row to attach the file to
    useEffect(() => {
        const loadLeadServices = async () => {
            if (!leadData?.id) return;
            try {
                const res = await api.get(`lead-services/by-lead/${leadData.id}`);
                const options = res.data || [];
                setLeadServiceOptions(options);
                if (options.length === 1) {
                    setSelectedLeadServiceId(String(options[0].id));
                }
            } catch (error) {
                console.error('Error loading lead services:', error);
            }
        };
        loadLeadServices();
    }, [leadData?.id]);
    // Function to download file
    const handleDownloadFile = async (file) => {
        try {
            // Non-ProposalDocument sources (CID1/CID2 lead files, invoices, payments) carry their own
            // ready-to-hit download route in filePath - proposal-documents endpoint only serves source==='Proposal'.
            // filePath comes back prefixed with /api (backend absolute route); the api client's baseURL
            // already ends in /api, so strip the duplicate prefix before use.
            const downloadUrl = file.source && file.source !== 'Proposal' && file.filePath
                ? file.filePath.replace(/^\/api(?=\/)/, '')
                : `/crm/proposal-documents/download/${file.id}`;
            // Real API call
            const response = await api.get(downloadUrl, {
                responseType: 'blob'
            });
            // Create download link
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', file.fileName || file.name || 'file');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            setAlert({
                type: 'success',
                message: `File "${file.fileName}" downloaded successfully!`
            });
        } catch (error) {
            console.error('Error downloading file:', error);
            console.error('Error details:', error.response?.data);
            setAlert({
                type: 'danger',
                message: 'Failed to download file: ' + (error.response?.data?.message || error.message)
            });
        }
    };
    // Function to delete file
    const handleDeleteFile = (file) => {
        if (file.source && file.source !== 'Proposal') {
            setAlert({
                type: 'warning',
                message: `"${file.fileName}" is managed from its original record (${file.source}) and can't be deleted here.`
            });
            return;
        }
        setFileToDelete(file);
        setShowDeleteFileModal(true);
    };
    // Function to confirm delete file
    const confirmDeleteFile = async () => {
        if (!fileToDelete) return;
        try {
            // Real API call
            await api.delete(`/crm/proposal-documents/${fileToDelete.id}`);
            setAlert({
                type: 'success',
                message: `File "${fileToDelete.fileName}" deleted successfully!`
            });
            // Reload files list to reflect the deletion
            await loadFiles();
        } catch (error) {
            console.error('Error deleting file:', error);
            console.error('Error details:', error.response?.data);
            setAlert({
                type: 'danger',
                message: 'Failed to delete file: ' + (error.response?.data?.message || error.message)
            });
        } finally {
            setShowDeleteFileModal(false);
            setFileToDelete(null);
        }
    };
    // Function to upload file
    const handleUploadFile = async (file, description = '', documentType = 'attachment') => {
        // CID1/CID2/Other go to the selected lead service, not the proposal-documents table
        if (uploadCategory !== 'Proposal') {
            if (!selectedLeadServiceId) {
                setAlert({ type: 'warning', message: 'Please select which service this file belongs to.' });
                return;
            }
            setUploadingFile(true);
            try {
                const formData = new FormData();
                const partName = uploadCategory === 'CID1' ? 'cid1' : uploadCategory === 'CID2' ? 'cid2' : 'other';
                formData.append(partName, file);
                await api.patch(`lead-services/${selectedLeadServiceId}/files`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
                setAlert({
                    type: 'success',
                    message: `File "${file.name}" uploaded successfully!`
                });
                await loadFiles();
            } catch (error) {
                console.error('Error uploading file:', error);
                console.error('Error details:', error.response?.data);
                setAlert({
                    type: 'danger',
                    message: 'Failed to upload file: ' + (error.response?.data?.message || error.message)
                });
            } finally {
                setUploadingFile(false);
            }
            return;
        }
        setUploadingFile(true);
        try {
            // Get actual proposal ID from lead ID
            const proposalId = await getProposalId(id);
            const formData = new FormData();
            formData.append('file', file);
            if (description) {
                formData.append('description', description);
            }
            formData.append('documentType', documentType);
            const response = await api.post(`crm/proposal-documents/proposal/${proposalId}/upload`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            setAlert({
                type: 'success',
                message: `File "${file.name}" uploaded successfully!`
            });
            // Reload files list to show the new file
            await loadFiles();
        } catch (error) {
            console.error('Error uploading file:', error);
            console.error('Error details:', error.response?.data);
            setAlert({
                type: 'danger',
                message: 'Failed to upload file: ' + (error.response?.data?.message || error.message)
            });
        } finally {
            setUploadingFile(false);
        }
    };
    // Dropzone inside the Upload File modal - uploads immediately on drop/select
    const onDropUploadFile = useCallback((acceptedFiles) => {
        const file = acceptedFiles[0];
        if (file) {
            handleUploadFile(file);
            setShowUploadModal(false);
        }
        // eslint-disable-next-line
    }, [uploadCategory, selectedLeadServiceId]);
    const { getRootProps: getUploadRootProps, getInputProps: getUploadInputProps, isDragActive: isUploadDragActive } = useDropzone({
        onDrop: onDropUploadFile,
        maxFiles: 1,
        multiple: false,
        disabled: uploadingFile || (uploadCategory !== 'Proposal' && !selectedLeadServiceId)
    });
    // Badge color for the file "Source" column - shows where a file came from
    // (uploaded directly on this proposal, or pulled in from the associated lead/invoice/payment record)
    const getFileSourceBadge = (category) => {
        const colors = {
            'CID1': 'info',
            'CID2': 'info',
            'Other Files': 'info',
            'Invoice': 'success',
            'Payment': 'warning',
            'Lead': 'info',
            'Proposal': 'primary',
            'Proposal Document': 'primary'
        };
        return `badge badge-outline text-${colors[category] || 'secondary'}`;
    };
    // File table columns configuration
    const fileColumns = [
        {
            key: 'fileName',
            label: 'File Name',
            render: (fileName, file) => (
                <div className="d-flex align-items-center">
                    {getFileIcon(file.fileName || file.name)}
                    <span className="fw-bold">{file.fileName || file.name || 'Unknown File'}</span>
                </div>
            ),
            sortable: true
        },
        {
            key: 'category',
            label: 'Source',
            render: (category, file) => {
                const label = file.category || file.source || 'Proposal';
                return <span className={getFileSourceBadge(label)}>{label}</span>;
            },
            sortable: true
        },
        {
            key: 'fileSize',
            label: 'File Size',
            render: (fileSize, file) => (
                <span className="text-muted">{formatFileSize(fileSize || file.fileSize || file.size || 0)}</span>
            ),
            sortable: true
        },
        {
            key: 'uploadedBy',
            label: 'Uploaded By',
            render: (uploadedBy, file) => (
                <div>
                    <div className="fw-bold">{uploadedBy || file.uploadedBy || file.uploaded_by || 'Unknown User'}</div>
                </div>
            ),
            sortable: true
        },
        {
            key: 'uploadDate',
            label: 'Upload Date',
            render: (uploadDate, file) => (
                <span className="text-muted">{formatDate(uploadDate || file.uploadDate || file.upload_date || file.createdAt)}</span>
            ),
            type: 'date',
            sortable: true
        }
    ];
    // Reload approval status when proposal data changes
    useEffect(() => {
        if (proposalData) {
            loadApprovalStatus();
        }
    }, [proposalData]);
    // Set selected proposal stage when proposal data and stages are loaded
    useEffect(() => {
        if (proposalData && proposalStages.length > 0) {
            // Try to find the current proposal stage
            const currentStageId = proposalData.proposalStageId || proposalData.stageId;

            // Check if currentStageId exists and is valid (not null, undefined, or empty)
            if (currentStageId != null && currentStageId !== '' && currentStageId !== 0) {
                const foundStage = proposalStages.find(stage => stage.id === parseInt(currentStageId));
                if (foundStage) {
                    setSelectedProposalStage(currentStageId.toString());
                    defaultStageSavedRef.current = false; // Reset ref when valid stage is found
                    return; // Exit early if stage is found
                }
            }

            // Default to id 1 if no current stage is set or stage not found
            // Only save to database once to prevent duplicate API calls
            const defaultStage = proposalStages.find(stage => stage.id === 1);
            if (defaultStage && !defaultStageSavedRef.current) {
                // Update UI state
                setSelectedProposalStage('1');
                // Mark as saved to prevent duplicate saves
                defaultStageSavedRef.current = true;
                // Save to database
                const saveDefaultStage = async () => {
                    try {
                        await api.put(`/crm/proposals/${id}/update-stage`, {
                            proposalStageId: '1'
                        });
                    } catch (error) {
                        console.error('Error saving default proposal stage:', error);
                        // Reset ref on error so it can be retried
                        defaultStageSavedRef.current = false;
                        // Don't show alert for default setting to avoid noise
                    }
                };
                saveDefaultStage();
            } else if (!defaultStage) {
                console.warn('Proposal stage with id 1 not found in stages list:', proposalStages);
            }
        }
    }, [proposalData, proposalStages, id]);

    // Sync tagging state from proposal data
    useEffect(() => {
        if (proposalData && Array.isArray(proposalData.taggingIds)) {
            const ids = proposalData.taggingIds.map((n) => (typeof n === 'number' ? n : parseInt(n, 10)));
            setSavedTaggingIds(ids);
            setSelectedTaggingIds(ids);
        }
    }, [proposalData?.id, proposalData?.taggingIds]);

    // Fetch tagging options for proposal module
    useEffect(() => {
        setLoadingTaggingOptions(true);
        api.get('/md/tagging', { params: { moduleKey: 'proposal' } })
            .then((res) => {
                const list = Array.isArray(res.data) ? res.data : [];
                setTaggingOptions(list);
            })
            .catch((err) => {
                console.error('Error fetching tagging options:', err);
                setTaggingOptions([]);
            })
            .finally(() => setLoadingTaggingOptions(false));
    }, []);

    // Fetch reason-loss options when lost modal opens
    useEffect(() => {
        if (!showLostReasonModal) return;
        setLoadingReasonLoss(true);
        setReasonLossOptions([]);
        api.get('/crm/reason-loss/all')
            .then((res) => {
                const list = Array.isArray(res.data) ? res.data : [];
                setReasonLossOptions(list);
            })
            .catch((error) => {
                console.error('Error fetching reason loss options:', error);
                setReasonLossOptions([]);
            })
            .finally(() => {
                setLoadingReasonLoss(false);
            });
    }, [showLostReasonModal]);

    const handleTaggingChange = async (name, value) => {
        const ids = Array.isArray(value) ? value.map((v) => (typeof v === 'number' ? v : parseInt(v, 10))) : [];
        setSelectedTaggingIds(ids);
        if (!proposalData?.id) return;
        setSavingTagging(true);
        try {
            await api.put(`/crm/proposals/${proposalData.id}/taggings`, { taggingIds: ids });
            setSavedTaggingIds([...ids]);
            setAlert({ type: 'success', message: 'Tagging updated.' });
        } catch (err) {
            console.error('Error saving proposal taggings:', err);
            setSelectedTaggingIds([...savedTaggingIds]);
            setAlert({ type: 'danger', message: err?.response?.data?.message || 'Failed to save tagging.' });
        } finally {
            setSavingTagging(false);
        }
    };

    // Handle proposal stage change
    const handleProposalStageChange = async (stageId) => {
        const selectedStage = proposalStages.find(stage => stage.id === parseInt(stageId));
        if (!selectedStage) return;

        const isLostStage = selectedStage.name && String(selectedStage.name).toLowerCase().includes('lost');
        if (isLostStage) {
            setPendingLostStageId(stageId);
            setLostReason('');
            setNote('');
            setShowLostReasonModal(true);
            return;
        }

        setSelectedProposalStage(stageId);
        try {
            await api.put(`/crm/proposals/${id}/update-stage`, {
                proposalStageId: stageId
            });
            setAlert({
                type: 'success',
                message: `Proposal stage updated to: ${selectedStage.name}`
            });
        } catch (error) {
            console.error('Error updating proposal stage:', error);
            setAlert({
                type: 'danger',
                message: 'Failed to update proposal stage'
            });
        }
    };

    const confirmLostStage = async () => {
        if (!lostReason || !pendingLostStageId) return;
        setIsSubmittingLost(true);
        try {
            // Use real API to update stage and persist loss reason + note
            await api.put(`/crm/proposals/${id}/update-stage`, {
                proposalStageId: pendingLostStageId,
                reasonLossId: lostReason,
                noteReasonLoss: note
            });

            const selectedStage = proposalStages.find((s) => s.id === parseInt(pendingLostStageId));
            const reasonLabel = reasonLossOptions.find(
                (r) => String(r.id) === String(lostReason) || r.id === parseInt(lostReason, 10)
            );
            const reasonDisplay = reasonLabel ? (reasonLabel.name || reasonLabel.label || '') : '';

            setSelectedProposalStage(pendingLostStageId);
            setShowLostReasonModal(false);
            setPendingLostStageId(null);
            setLostReason('');
            setNote('');

            // Refresh proposal data to get updated reason loss info
            try {
                const refreshedRes = await api.get(`crm/proposals/detail/lead/${id}`);
                if (refreshedRes.data) {
                    const fixedData = {
                        ...refreshedRes.data,
                        statusDesc: formatStatusDesc(refreshedRes.data.statusDesc),
                        statusApproval: formatStatusDesc(refreshedRes.data.statusApproval || refreshedRes.data.statusDesc),
                        statusProposalDesc: formatStatusDesc(refreshedRes.data.statusProposalDesc)
                    };
                    setProposalData(fixedData);
                }
            } catch (refreshError) {
                console.warn('Failed to refresh proposal data after update:', refreshError);
            }

            setAlert({
                type: 'success',
                message: reasonDisplay
                    ? `Proposal marked as lost: ${selectedStage?.name || 'Lost'}. Reason: ${reasonDisplay}`
                    : `Proposal marked as lost: ${selectedStage?.name || 'Lost'}`
            });
        } catch (error) {
            console.error('Error updating proposal stage:', error);
            setAlert({
                type: 'danger',
                message: error.response?.data?.message || 'Failed to update proposal stage'
            });
        } finally {
            setIsSubmittingLost(false);
        }
    };

    const closeLostReasonModal = () => {
        setShowLostReasonModal(false);
        setPendingLostStageId(null);
        setLostReason('');
        setNote('');
    };
    const handleEdit = () => {
        navigate(`/proposals/edit/${id}`);
    };
    // Calculate investment breakdown dynamically based on year options stored in proposal data
    const calculateInvestmentBreakdown = (proposalSections) => {
        let allYears = new Set();
        let breakdown = [];
        let totalsByYear = {};
        // Helper function to get years based on selected year options from table (exactly like EditProposal)
        const getYearsForSelectedOption = (yearType, selectedYear, dynamicYearRange = null) => {
            if (yearType === 0) {
                // Every year - create a continuous range from min to max year based on Select Year items
                let years = new Set();
                if (dynamicYearRange && dynamicYearRange.length > 0) {
                    // For Every Year items, only use the years where Select Year items exist
                    dynamicYearRange.forEach(year => {
                        years.add(year);
                    });

                } else {
                    // Fallback to 5 years from current year if no Select Year items available
                    const currentYear = new Date().getFullYear();
                    for (let i = 0; i <= 4; i++) {
                        years.add(currentYear + i);
                    }
                }
                // Convert back to sorted array
                return Array.from(years).sort((a, b) => a - b);
            } else if (yearType === 1) {
                // Select Year - use the selectedYear from the table
                return [selectedYear || new Date().getFullYear()];
            } else {
                // Default fallback - calculate for 4 years from current year
                const currentYear = new Date().getFullYear();
                return [currentYear, currentYear + 1, currentYear + 2, currentYear + 3];
            }
        };
        // Convert proposal_sections to proposalServices format (like EditProposal)
        const proposalServices = proposalSections.map(section => ({
            service: section.type || 'Service',
            standards: section.services.map(service => {
                // Handle both camelCase (API v2) and snake_case (API v1) field names
                const serviceItemId = service.serviceItemId || service.service_item_id || service.service_item || service.serviceItem;
                const yearType = service.yearType ?? service.year_type ?? 0;
                const selectedYear = service.selectedYear || service.selected_year || new Date().getFullYear();
                const qty = service.qty != null ? service.qty : (service.quantity ?? 0);
                const unitPrice = service.unitPriceBaseCurrency || service.unit_price_base_currency || service.unitPrice || service.unit_price || 0;
                const unit = service.unit || service.unitName || '';
                const children = service.children || service.sub_services || service.productCategories || [];
                return {
                    standard: service.standard || 'Standard',
                    version: service.version || '',
                    scope: service.scope || '',
                    serviceItem: serviceItemId,
                    yearType: Number(yearType),
                    selectedYear: Number(selectedYear) || new Date().getFullYear(),
                    qty: qty,
                    unit: unit,
                    unitPrice: unitPrice,
                    productCategories: children.map(child => {
                        const childServiceItemId = child.serviceItemId || child.service_item_id || child.service_item || child.serviceItem;
                        const childYearType = child.yearType ?? child.year_type ?? 0;
                        const childSelectedYear = child.selectedYear || child.selected_year || new Date().getFullYear();
                        const childQty = child.qty != null ? child.qty : (child.quantity ?? 0);
                        const childUnitPrice = child.unitPriceBaseCurrency || child.unit_price_base_currency || child.unitPrice || child.unit_price || 0;
                        return {
                            serviceItem: childServiceItemId,
                            yearType: Number(childYearType),
                            selectedYear: Number(childSelectedYear) || new Date().getFullYear(),
                            qty: childQty,
                            unit: child.unit || child.unitName || '',
                            unitPrice: childUnitPrice
                        };
                    })
                };
            })
        }));
        // First pass: collect all years from non-every-year service items to determine dynamic range
        let dynamicYearRange = new Set();
        let hasSelectYearItems = false;

        proposalServices.forEach((section, sectionIdx) => {
            (section.standards || []).forEach((standard, standardIdx) => {
                // Main row: service item (if present)
                if (standard.serviceItem) {
                    const yearType = standard.yearType || 0;
                    const selectedYear = standard.selectedYear || new Date().getFullYear();

                    if (yearType !== 0) { // Collect years from non-every-year items
                        hasSelectYearItems = true;
                        const itemYears = getYearsForSelectedOption(yearType, selectedYear);
                        itemYears.forEach(y => dynamicYearRange.add(y));
                    }
                }

                // Children rows: service items in productCategories
                if (standard.productCategories && Array.isArray(standard.productCategories)) {
                    standard.productCategories.forEach((pc, productCategoryIdx) => {
                        if (pc.serviceItem) {
                            const yearType = pc.yearType || 0;
                            const selectedYear = pc.selectedYear || new Date().getFullYear();

                            if (yearType !== 0) { // Collect years from non-every-year items
                                hasSelectYearItems = true;
                                const itemYears = getYearsForSelectedOption(yearType, selectedYear);
                                itemYears.forEach(y => dynamicYearRange.add(y));
                            }
                        }
                    });
                }
            });
        });

        // If no Select Year items found, use current year as fallback
        if (!hasSelectYearItems) {
            dynamicYearRange.add(new Date().getFullYear());
        }
        // Convert dynamic year range to sorted array
        const dynamicYearArray = Array.from(dynamicYearRange).sort((a, b) => a - b);

        // If no dynamic year range found, create a default one
        if (dynamicYearArray.length === 0) {
            const currentYear = new Date().getFullYear();
            for (let i = 0; i <= 1; i++) { // Just 2 years as requested
                dynamicYearArray.push(currentYear + i);
            }
        }
        // Second pass: process all service items with the dynamic range
        proposalServices.forEach((section, sectionIdx) => {
            const serviceLabel = section.service || `Service ${section.service}`;

            // ✅ FIX: Group service items by standard name to avoid duplicate standard headers
            const standardsMap = new Map();

            (section.standards || []).forEach((standard, standardIdx) => {
                const standardLabel = standard.standard || `Standard ${standardIdx + 1}`;
                const version = standard.version || ''; // ✅ TAMBAHAN: Get version from standard data
                const standardScheme = standard.standard_scheme || ''; // ✅ TAMBAHAN: Get standard_scheme from standard data
                const scope = standard.scope || ''; // Per-standard scope

                // ✅ FIX: Use standard:version:scheme as key to group by standard+version+scheme combination
                const standardKey = standardLabel +
                    (version && version.trim() !== '' ? ':' + version : '') +
                    (standardScheme && standardScheme.trim() !== '' ? ':' + standardScheme : '');

                // Get or create the standard entry
                if (!standardsMap.has(standardKey)) {
                    standardsMap.set(standardKey, {
                        standard: standardLabel,
                        version: version, // ✅ TAMBAHAN: Store version in the entry
                        standard_scheme: standardScheme, // ✅ TAMBAHAN: Store standard_scheme in the entry
                        scope: scope, // Per-standard scope
                        serviceItems: []
                    });
                }
                const standardEntry = standardsMap.get(standardKey);

                // Main row: service item (if present)
                if (standard.serviceItem && standard.qty != null && standard.qty > 0) {
                    const itemLabel = `Service Item ${standard.serviceItem}`;
                    const qty = standard.qty != null ? parseFloat(standard.qty) : 0;
                    const price = (standard.unitPrice && qty) ? parseFloat(standard.unitPrice || 0) * qty : 0;
                    // Get year option from table selection
                    const yearType = standard.yearType || 0;
                    const selectedYear = standard.selectedYear || new Date().getFullYear();
                    const itemYears = getYearsForSelectedOption(yearType, selectedYear, dynamicYearArray);

                    // Add years to allYears set
                    itemYears.forEach(y => allYears.add(y));
                    // Map price to the correct years
                    itemYears.forEach(year => { totalsByYear[year] = (totalsByYear[year] || 0) + price; });
                    standardEntry.serviceItems.push({
                        serviceItem: itemLabel,
                        prices: [price],
                        years: itemYears,
                        yearType: yearType,
                        selectedYear: selectedYear,
                        qty: qty, // Use qty from proposal standard items
                        unit: standard.unit || '' // ✅ TAMBAHAN: Include unit
                    });
                }
                // Children rows: service items in productCategories
                if (standard.productCategories && Array.isArray(standard.productCategories)) {
                    standard.productCategories.forEach((pc, productCategoryIdx) => {
                        if (pc.serviceItem && pc.qty != null && pc.qty > 0) {
                            const itemLabel = `Service Item ${pc.serviceItem}`;
                            const qty = pc.qty != null ? parseFloat(pc.qty) : 0;
                            const price = (pc.unitPrice && qty) ? parseFloat(pc.unitPrice || 0) * qty : 0;
                            // Get year option from table selection
                            const yearType = pc.yearType || 0;
                            const selectedYear = pc.selectedYear || new Date().getFullYear();
                            const itemYears = getYearsForSelectedOption(yearType, selectedYear, dynamicYearArray);

                            // Add years to allYears set
                            itemYears.forEach(y => allYears.add(y));
                            // Map price to the correct years
                            itemYears.forEach(year => { totalsByYear[year] = (totalsByYear[year] || 0) + price; });
                            standardEntry.serviceItems.push({
                                serviceItem: itemLabel,
                                prices: [price],
                                years: itemYears,
                                yearType: yearType,
                                selectedYear: selectedYear,
                                qty: qty, // Use qty from proposal standard items
                                unit: pc.unit || '' // ✅ TAMBAHAN: Include unit
                            });
                        }
                    });
                }
            });

            // Convert map to array for the breakdown
            const standardsArr = Array.from(standardsMap.values());
            breakdown.push({ service: serviceLabel, standards: standardsArr });
        });
        const sortedYears = Array.from(allYears).sort((a, b) => a - b);
        if (sortedYears.length > 0) {
            setInvestmentBreakdown({
                years: sortedYears,
                breakdown,
                totals: sortedYears.map(y => totalsByYear[y] || 0)
            });
            setShowBreakdown(true);
        } else {
            // If no years found, hide the breakdown
            setShowBreakdown(false);
            setInvestmentBreakdown(null);
        }
    };
    // Update the useEffect to call calculateInvestmentBreakdown directly
    useEffect(() => {
        // Simulate API call
        const fetchData = async () => {
            try {
                const res = await api.get(`crm/proposals/detail/lead/${id}`);
                // Format status descriptions to proper case
                const fixedData = {
                    ...res.data,
                    statusDesc: formatStatusDesc(res.data.statusDesc),
                    statusApproval: formatStatusDesc(res.data.statusApproval || res.data.statusDesc),
                    statusProposalDesc: formatStatusDesc(res.data.statusProposalDesc)
                };
                setProposalData(fixedData);
                // Try to fetch investment breakdown from API first
                try {
                    await fetchInvestmentBreakdown(fixedData);
                } catch (error) {
                    // Fallback to local calculation if API fails
                    if (res.data && res.data.proposal_sections) {
                        calculateInvestmentBreakdown(res.data.proposal_sections);
                    }
                }
                // Automatically load document if available
                if (res.data && (res.data.proposalPdfFillPdf || res.data.proposalPdfFill)) {
                    // Wait for proposalData to be set before downloading document
                    setTimeout(() => {
                        downloadAndDisplayFilledDocument();
                    }, 100);
                }
            } catch (error) {
                console.error('Error fetching proposal:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [id]);
    // Also add a useEffect to recalculate when proposalData changes
    useEffect(() => {
        if (proposalData && proposalData.proposal_sections) {
            // Add a small delay to ensure all data is loaded
            const timer = setTimeout(() => {
                // Try API first, then fallback to local calculation
                fetchInvestmentBreakdown().catch(() => {
                    calculateInvestmentBreakdown(proposalData.proposal_sections);
                });
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [proposalData]);
    // Load email settings and templates with better error handling
    useEffect(() => {
        loadEmailData();
    }, []);
    // Separate function for loading email data
    const loadEmailData = async () => {
        try {
            setIsLoadingEmailData(true);
            setEmailDataLoaded(false);

            // Load email settings
            const settingsResponse = await api.get('/email/settings');

            if (settingsResponse.data) {
                setEmailSettings(settingsResponse.data);
            } else {
                setEmailSettings(null);
            }

            // Load email templates
            const templatesResponse = await getProposalEmailTemplates();

            if (templatesResponse && Array.isArray(templatesResponse)) {
                setEmailTemplates(templatesResponse);
            } else {
                setEmailTemplates([]);
            }
            setEmailDataLoaded(true);
        } catch (error) {
            console.error('Error loading email data:', error);
            setEmailSettings(null);
            setEmailTemplates([]);
            setEmailDataLoaded(true);
        } finally {
            setIsLoadingEmailData(false);
        }
    };
    // Update send to client function to include email sending
    // Validate workflows before allowing send
    const checkServiceItemsWorkflow = async () => {
        setLoadingWorkflowValidation(true);
        try {
            // Try to fetch proposal with proposalServices (for ids)
            let workflowData = null;
            try {
                const workflowResponse = await api.get(`/crm/proposals/lead/${id}`);
                if (Array.isArray(workflowResponse.data) && workflowResponse.data.length > 0) {
                    workflowData = workflowResponse.data[0];
                }
            } catch (_) { }

            const itemsWithout = [];
            if (workflowData && Array.isArray(workflowData.proposalServices)) {
                workflowData.proposalServices.forEach((section) => {
                    if (!section || typeof section === 'number') return;
                    (section.standards || []).forEach((std) => {
                        const hasWorkflowAssigned = std.workFlowIdSystem != null || std.workFlowIdChoice != null;
                        if (!hasWorkflowAssigned) {
                            itemsWithout.push({
                                serviceName: section.serviceName || section.serviceId || 'Service',
                                standardName: std.standardName || std.standardId || 'Standard',
                                productCategoryName: std.productCategoryName || std.productCategoryId || '-',
                                serviceItemName: std.serviceItemName || std.serviceItemId || '-',
                            });
                        }
                        (std.children || []).forEach((child) => {
                            const childHas = child.workFlowIdSystem != null || child.workFlowIdChoice != null;
                            if (!childHas) {
                                itemsWithout.push({
                                    serviceName: section.serviceName || section.serviceId || 'Service',
                                    standardName: child.standardName || child.standardId || std.standardName || 'Standard',
                                    productCategoryName: child.productCategoryName || child.productCategoryId || '-',
                                    serviceItemName: child.serviceItemName || child.serviceItemId || '-',
                                });
                            }
                        });
                    });
                });
            }

            if (itemsWithout.length > 0) {
                setServiceItemsWithoutWorkflow(itemsWithout);
                setShowWorkflowValidationModal(true);
                return false;
            }
            return true;
        } catch (e) {
            // If validation fails unexpectedly, block send conservatively
            setServiceItemsWithoutWorkflow([]);
            setShowWorkflowValidationModal(true);
            return false;
        } finally {
            setLoadingWorkflowValidation(false);
        }
    };

    const onSendToClient = async () => {
        // Validate Total Cost is not 0 — usually caused by an item left without a selected Year
        const grandTotalValue = parseFloat(proposalData?.grandTotal) || 0;
        if (grandTotalValue <= 0) {
            setAlert({
                type: 'warning',
                message: 'Cannot send to client: Total cost is 0. Please select a year for one of the item(s) in this proposal.'
            });
            return;
        }

        const canProceed = await checkServiceItemsWorkflow();
        if (!canProceed) return;
        setShowSendToClientModal(true);
    };
    // Function to confirm send to client
    const confirmSendToClient = async () => {
        setLoadingWorkflow(true);
        setIsProcessingSend(true);
        try {
            // Fetch workflow items yang perlu review
            const response = await api.get(`/crm/proposals/${id}/workflow-review`);
            // Jika tidak ada workflow, langsung kirim email
            if (!response.data || response.data.length === 0) {
                // Lanjutkan ke pengiriman email (tanpa modal)
                await handleConfirmSendToClient();
                return;
            }
            // Jika ada workflow items, tampilkan modal review dan beri info jelas
            setWorkflowItems(response.data);

            // ✅ TAMBAHAN: Fetch latest note from proposal history
            try {
                const proposalId = await getProposalId(id);
                if (proposalId) {
                    const historyRes = await api.get(`/crm/proposals/${proposalId}/history`);
                    if (historyRes.data && Array.isArray(historyRes.data)) {
                        // Find the most recent SENT type history entry with a note
                        const sentHistory = historyRes.data
                            .filter(h => h.type === 'SENT' || h.type === 'sent')
                            .filter(h => h.notes && h.notes.includes('Note:'))
                            .sort((a, b) => {
                                const dateA = new Date(a.createdAt || a.created_at || 0);
                                const dateB = new Date(b.createdAt || b.created_at || 0);
                                return dateB - dateA;
                            })[0];

                        if (sentHistory && sentHistory.notes) {
                            // Extract note text (text after "Note:")
                            const noteMatch = sentHistory.notes.match(/Note:\s*(.+)/);
                            if (noteMatch && noteMatch[1]) {
                                setWorkflowNote(noteMatch[1].trim());
                            } else {
                                setWorkflowNote(''); // Reset if no note found
                            }
                        } else {
                            setWorkflowNote(''); // Reset if no history found
                        }
                    } else {
                        setWorkflowNote(''); // Reset if no history data
                    }
                }
            } catch (noteError) {
                console.warn('Could not fetch previous note:', noteError);
                setWorkflowNote(''); // Reset on error
                // Continue without pre-filling note
            }

            setShowWorkflowModal(true);
            // ✅ FIX: Don't update status here - only update when user clicks "Ok" in handleSetNeedApproval
            // Status will be updated in handleSetNeedApproval when user confirms
        } catch (error) {
            console.error('Error fetching workflow items:', error);
            setAlert({
                type: 'danger',
                message: 'Failed to fetch workflow items for review.'
            });
        } finally {
            setLoadingWorkflow(false);
            setIsProcessingSend(false);
        }
    };
    const handleWorkflowModalClose = () => {
        setShowWorkflowModal(false);
        setWorkflowItems([]);
        setWorkflowNote(''); // ✅ Reset note when closing modal
    };
    // Update handleConfirmSendToClient dengan auto-reload
    const handleConfirmSendToClient = async () => {
        try {
            setIsSendingEmail(true);
            setEmailStatus(null);
            // Auto-reload email data if it's null
            let currentEmailSettings = emailSettings;
            let currentEmailTemplates = emailTemplates;
            if (!emailSettings || emailTemplates.length === 0) {
                try {
                    const settingsResponse = await api.get('/email/settings');
                    const templatesResponse = await getProposalEmailTemplates();
                    if (settingsResponse.data) {
                        currentEmailSettings = settingsResponse.data;
                        setEmailSettings(settingsResponse.data);
                    }
                    if (templatesResponse && Array.isArray(templatesResponse)) {
                        currentEmailTemplates = templatesResponse;
                        setEmailTemplates(templatesResponse);
                    }
                } catch (error) {
                    console.error('Error reloading email data:', error);
                }
            }
            // First, send proposal to client (existing workflow)
            await api.post(`/crm/proposals/${id}/send-to-client`);
            // Update status approval and proposal for cases without workflow
            try {
                // Update status approval to 'Approved' and status proposal to 'Send to Client'
                await api.put(`/crm/proposals/${id}/update-status-no-workflow`, {
                    status: 2, // Approved
                    statusDesc: "Approved",
                    statusProposal: 2, // Send to Client
                    statusProposalDesc: "Send to Client"
                });
                // Refresh proposal data to get the latest status
                try {
                    const refreshedRes = await api.get(`/crm/proposals/detail/lead/${id}`);
                    if (refreshedRes.data) {
                        // Format status descriptions to proper case
                        const fixedData = {
                            ...refreshedRes.data,
                            statusDesc: formatStatusDesc(refreshedRes.data.statusDesc),
                            statusApproval: formatStatusDesc(refreshedRes.data.statusApproval || refreshedRes.data.statusDesc),
                            statusProposalDesc: formatStatusDesc(refreshedRes.data.statusProposalDesc)
                        };
                        setProposalData(fixedData);
                    }
                } catch (refreshError) {
                    console.warn('⚠️ Failed to refresh proposal data:', refreshError);
                }
            } catch (statusError) {
                console.warn('⚠️ Failed to update status:', statusError);
                // Continue with email sending even if status update fails
            }
            // ✅ MODIFIKASI: Gunakan email_pembuat sebagai tujuan email (dari users.email)
            const emailPembuat = proposalData?.email_pembuat || '';
            const canSendEmail = currentEmailSettings && emailPembuat;

            // If no email pembuat found, show warning and skip email
            if (!emailPembuat) {
                console.warn('⚠️ No email pembuat found in proposal data');
                setAlert({
                    type: 'warning',
                    message: 'Proposal sent to client successfully! Email notification skipped: No email pembuat found.'
                });
                setShowWorkflowModal(false);
                setWorkflowItems([]);
                return;
            }
            if (canSendEmail) {
                setEmailStatus('sending email.....');
                // Try to send email to pembuat proposal
                try {
                    await sendProposalEmailToClient(emailPembuat, currentEmailSettings, currentEmailTemplates, proposalData);
                    setEmailStatus('success');
                    setAlert({
                        type: 'success',
                        message: 'Proposal sent to client successfully and email notification sent!'
                    });
                } catch (emailError) {
                    console.warn('✗ Email sending failed:', emailError);
                    setEmailStatus('failed');
                    setAlert({
                        type: 'warning',
                        message: 'Proposal sent to client successfully! Email notification failed: ' + emailError.message
                    });
                }
            } else {
                setEmailStatus('skipped');
                // No email settings or client email, just send proposal
                setAlert({
                    type: 'success',
                    message: 'Proposal sent to client successfully! Email notification skipped: email settings are not configured.'
                });
            }
            setShowWorkflowModal(false);
            setWorkflowItems([]);
        } catch (error) {
            console.error('Error sending proposal to client:', error);
            setEmailStatus('failed');
            setAlert({
                type: 'danger',
                message: 'Failed to send proposal to client: ' + (error.response?.data?.message || error.message)
            });
        } finally {
            setIsSendingEmail(false);
        }
    };
    // ===== Template Processing Helpers (reused from Edit) =====
    const getProposalId = async (leadId) => {
        try {
            const res = await api.get(`crm/proposals/id-by-lead/${leadId}`);
            return typeof res.data === 'object' ? res.data.id : res.data;
        } catch (error) {
            throw new Error('Proposal not found for this lead');
        }
    };
    const fetchTemplateData = async (proposalId, currencyCode = 'IDR', leadData = null) => {
        try {
            const response = await api.get(`crm/proposals/${proposalId}/template-dummy-data`, {
                params: { currencyCode }
            });


            // ✅ TAMBAHAN: Format data sebelum dikirim ke template dengan currency, proposal data, and lead data
            const formattedData = await formatTemplateData(response.data, currencyCode, proposalData, leadData);


            // ✅ DEBUG: Log specific currency-related fields
            if (formattedData.service_items && formattedData.service_items.length > 0) {
            }
            if (formattedData.years && formattedData.years.length > 0) {
            }
            return formattedData;
        } catch (error) {
            console.error('Error in fetchTemplateData:', error);

            // ✅ FIX: Collect standards in fallback case (when backend fails)
            let standardsText = '';
            let standardsArray = [];
            if (proposalData && proposalData.proposal_sections) {
                const allStandards = proposalData.proposal_sections.flatMap(section =>
                    section.services?.map(service => service.standard) || []
                ) || [];
                const uniqueStandards = [...new Set(allStandards)];
                standardsText = uniqueStandards.join(', ');
                standardsArray = uniqueStandards.map(std => ({
                    name: std,
                    standard_scheme: '' // Scheme not available in frontend fallback
                }));
            }

            return {
                company_name: proposalData?.client?.name || 'Client',
                company_address: proposalData?.client?.address || '-',
                company_pic: leadData?.pic || proposalData?.client?.contact_person || '-',
                standard: standardsText,
                standards: standardsArray,
                standard_scheme: '',
                scope: '',
                proposal_number: proposalData?.proposal_number || '',
                proposal_date: proposalData?.dates?.proposal_date || '',
                project_name: '',
                pic_name: leadData?.pic || proposalData?.client?.contact_person || '',
                pic_phone: '',
                pic_email: '',
                service_items: [],
                years: [],
                grand_total: getCurrencyPrefix(currencyCode) + '0'
            };
        }
    };
    const fillDocxWithDummyData = async (file, proposalId) => {
        const arrayBuffer = await file.arrayBuffer();
        const zip = new PizZip(arrayBuffer);
        const templateData = await fetchTemplateData(proposalId, proposalCurrencyCode, leadData);
        // Pre-load the signature images
        let salesSignatureBuffer = null;
        let picSignatureBuffer = null;
        let assignedUserSignatureBuffer = null;
        try {
            // Fetch sales signature from API
            if (templateData.sales_signature) {
                try {
                    const apiUrl = process.env.REACT_APP_API_ENDPOINT;
                    let signaturePath = templateData.sales_signature;
                    const salesSignatureResponse = await fetch(`${apiUrl}/api/public/displayimage/${signaturePath}`);
                    if (salesSignatureResponse.ok) {
                        salesSignatureBuffer = await salesSignatureResponse.arrayBuffer();
                    } else {
                        console.error(`[ERROR] Failed to fetch sales signature: /api/public/displayimage/${signaturePath}, status: ${salesSignatureResponse.status}`);
                    }
                } catch (error) {
                    console.error(`[ERROR] Error fetching sales signature:`, error);
                }
            }
            // Fetch PIC signature from API (using assigned user signature as fallback)
            if (templateData.assigned_user_signature) {
                try {
                    let signaturePath = templateData.assigned_user_signature;
                    const assignedUserSignatureResponse = await fetch(`/api/public/displayimage/${signaturePath}`);
                    if (assignedUserSignatureResponse.ok) {
                        assignedUserSignatureBuffer = await assignedUserSignatureResponse.arrayBuffer();
                    } else {
                        console.error(`[ERROR] Failed to fetch assigned user signature: /api/public/displayimage/${signaturePath}, status: ${assignedUserSignatureResponse.status}`);
                    }
                } catch (error) {
                    console.error(`[ERROR] Error fetching assigned user signature:`, error);
                }
            }
            // Fallback logic: jika sales signature tidak ada, gunakan assigned user signature
            if (!salesSignatureBuffer && assignedUserSignatureBuffer) {
                salesSignatureBuffer = assignedUserSignatureBuffer;
            }
            // Fallback logic: jika pic signature tidak ada, gunakan assigned user signature
            if (!picSignatureBuffer && assignedUserSignatureBuffer) {
                picSignatureBuffer = assignedUserSignatureBuffer;
            }
            // Fallback logic: jika pic signature masih tidak ada, gunakan sales signature
            if (!picSignatureBuffer && salesSignatureBuffer) {
                picSignatureBuffer = salesSignatureBuffer;
            }
        } catch (error) {
            console.warn('Could not load signature images:', error);
        }
        // Configure image module for signature images only
        // Configure image module for signature images only
        const imageOpts = {
            centered: false, // Set to true to always center images
            fileType: "docx",
            getImage: function (tagValue, tagName) {
                // Handle signature images
                if (tagName === 'sales_signature') {
                    // Return the pre-loaded sales signature image buffer
                    if (salesSignatureBuffer) {
                        return salesSignatureBuffer;
                    }
                    return null;
                } else if (tagName === 'pic_signature') {
                    // Return the pre-loaded PIC signature image buffer
                    if (picSignatureBuffer) {
                        return picSignatureBuffer;
                    }
                    return null;
                }
                // For other image types, return null
                return null;
            },
            getSize: function (img, tagValue, tagName) {
                // Return fixed size for signature images
                if (tagName === 'sales_signature' || tagName === 'pic_signature') {
                    return [200, 100]; // width, height
                }
                return [200, 100]; // default size
            }
        };
        const imageModule = new ImageModule(imageOpts);
        const doc = new Docxtemplater(zip, {
            paragraphLoop: true,
            linebreaks: true,
            modules: [imageModule] // Attach the image module
        });
        // Check template variables in the document
        try {
            const templateVariables = doc.getFullText();
            // Find signature tags in template
            const signatureTags = templateVariables.match(/\{%[^%]+\}/g);
        } catch (error) {
            // Continue processing even if template check fails
        }
        doc.setData(templateData);
        try {
            doc.render();
        } catch (error) {
            throw error; // Re-throw error to be handled at higher level
        }
        const out = doc.getZip().generate({ type: 'blob', mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
        return postProcessDocxCheckboxes(out);
    };

    // Post-process the generated DOCX to replace ☒/☐ unicode chars with real Word FORMCHECKBOX fields.
    // This avoids the {@} raw-XML-in-loop corruption bug in docxtemplater.
    const postProcessDocxCheckboxes = async (docxBlob) => {
        const arrayBuffer = await docxBlob.arrayBuffer();
        const zip = new PizZip(arrayBuffer);
        let xml = zip.file('word/document.xml').asText();

        const buildCheckboxField = (checked, rPr, label) => {
            const checkedInner = checked ? '<w:checked/>' : '';
            const displayChar  = checked ? '&#9746;' : '&#9744;';
            return (
                `<w:r><w:fldChar w:fldCharType="begin"><w:ffData><w:checkBox><w:sizeAuto/>${checkedInner}</w:checkBox></w:ffData></w:fldChar></w:r>` +
                `<w:r><w:instrText xml:space="preserve"> FORMCHECKBOX </w:instrText></w:r>` +
                `<w:r><w:fldChar w:fldCharType="separate"/></w:r>` +
                `<w:r><w:t>${displayChar}</w:t></w:r>` +
                `<w:r><w:fldChar w:fldCharType="end"/></w:r>` +
                (label && label.trim()
                    ? `<w:r>${rPr || ''}<w:t xml:space="preserve">${label}</w:t></w:r>`
                    : '')
            );
        };

        // ── Pass 1: loop checkboxes — PUA sentinels in cmf_block runs ──
        const SENTINEL_CHECKED   = '\uE001';
        const SENTINEL_UNCHECKED = '\uE002';

        xml = xml.replace(/<w:r[^>]*>([\s\S]*?)<\/w:r>/g, (match, content) => {
            const isChecked   = content.includes(SENTINEL_CHECKED);
            const isUnchecked = content.includes(SENTINEL_UNCHECKED);
            if (!isChecked && !isUnchecked) return match;
            const rPrMatch   = content.match(/(<w:rPr>[\s\S]*?<\/w:rPr>)/);
            const rPr        = rPrMatch ? rPrMatch[1] : '';
            const sentinel   = isChecked ? SENTINEL_CHECKED : SENTINEL_UNCHECKED;
            const lm         = content.match(new RegExp(sentinel + '([^<]*)'));
            const label      = lm ? lm[1] : '';
            return buildCheckboxField(isChecked, rPr, label);
        });

        // ── Pass 2: standalone individual checkboxes — ASCII markers ──
        // Replaces <w:t>MARKER</w:t></w:r> only — avoids <w:r> boundary issues.
        const STANDALONE = [
            { marker: '##CMF_BASIC_CHK##',   checked: true  },
            { marker: '##CMF_BASIC_UNCHK##',  checked: false },
            { marker: '##CMF_BP_CHK##',       checked: true  },
            { marker: '##CMF_BP_UNCHK##',     checked: false },
            { marker: '##CMF_BENCH_CHK##',    checked: true  },
            { marker: '##CMF_BENCH_UNCHK##',  checked: false },
        ];
        STANDALONE.forEach(function(item) {
            xml = xml.replace(
                new RegExp('<w:t[^>]*>' + item.marker + '<\\/w:t><\\/w:r>', 'g'),
                function() { return '<w:t/></w:r>' + buildCheckboxField(item.checked, '', ''); }
            );
        });

        zip.file('word/document.xml', xml);
        return zip.generate({
            type: 'blob',
            mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        });
    };
    const downloadAndFillTemplate = async (templateId, proposalId) => {
        const response = await api.get(`/crm/proposal-templates/${templateId}/download-template`, { responseType: 'blob' });
        const file = new File([response.data], 'template.docx', { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
        const filledDocxBlob = await fillDocxWithDummyData(file, proposalId);
        return filledDocxBlob;
    };
    const uploadFilledDocument = async (fileBlob, proposalId) => {
        const formData = new FormData();
        formData.append('file', fileBlob, `proposal_${proposalId}_filled.docx`);
        await api.post(`/crm/proposals/${proposalId}/upload-filled-document`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
    };
    // processTemplateBeforeSend function removed - PDF creation is now handled separately via Create PDF button
    const handleSetNeedApproval = async () => {
        try {
            // ✅ TAMBAHAN: Send note along with the request
            await api.post(`/crm/proposals/${id}/set-need-approval`, {
                note: workflowNote || null
            });
            // Update status approval to 'NEED_APPROVAL' with consistent endpoint
            try {
                await api.put(`/crm/proposals/${id}/update-status-no-workflow`, {
                    status: 3, // NEED_APPROVAL
                    statusDesc: "NEED_APPROVAL",
                    statusProposal: 1, // Keep as Draft
                    statusProposalDesc: "Draft"
                });
            } catch (statusError) {
                console.warn('⚠️ Failed to update status via endpoint:', statusError);
            }
            setAlert({ type: 'success', message: 'Proposal status updated and in Need Approval!' });
            // Update state tombol langsung
            setSendToClientDisabled(true);
            setSendToClientLabel('Need Approval');
            // Refresh proposal data to get the latest status
            try {
                const refreshedRes = await api.get(`/crm/proposals/detail/lead/${id}`);
                if (refreshedRes.data) {
                    // Format status descriptions to proper case
                    const fixedData = {
                        ...refreshedRes.data,
                        statusDesc: formatStatusDesc(refreshedRes.data.statusDesc),
                        statusApproval: formatStatusDesc(refreshedRes.data.statusApproval || refreshedRes.data.statusDesc),
                        statusProposalDesc: formatStatusDesc(refreshedRes.data.statusProposalDesc)
                    };
                    setProposalData(fixedData);
                }
            } catch (refreshError) {
                console.warn('⚠️ Failed to refresh proposal data:', refreshError);
                // Fallback: Update proposal data status juga
                setProposalData(prev => {
                    const updated = {
                        ...prev,
                        status: 3, // Set status ke 3
                        statusDesc: formatStatusDesc("NEED_APPROVAL"),
                        statusApproval: formatStatusDesc("NEED_APPROVAL")
                    };
                    return updated;
                });
            }
            setShowWorkflowModal(false);
            setWorkflowItems([]);
            setWorkflowNote(''); // ✅ Reset note after submission
        } catch (error) {
            setAlert({ type: 'danger', message: 'Failed to update proposal status.' });
        }
    };
    // Update send to client state based on proposal status and approval status
    useEffect(() => {
        if (proposalData) {
            const status = proposalData.status;
            const statusProposal = proposalData.statusProposal;

            let isDisabled = false;

            // Check various possible status formats
            if (status === 'need_approval' ||
                status === 3 ||
                status === '3' ||
                status === 'Need Approval' ||
                status === 'NEED_APPROVAL' ||
                String(status).includes('3')) {
                isDisabled = true;
            }

            // Hide Send to Client button if STATUS PROPOSAL = "Accepted" (code 3)
            if (statusProposal === 3) {
                isDisabled = true;
            }

            // Also disable if STATUS APPROVAL = "Approved"
            if (proposalData.statusApproval === 'Approved') {
                isDisabled = true;
            }

            // Check approval status to determine if button should be disabled
            if (approvalStatus && approvalStatus.shouldDisableSendToClient) {
                isDisabled = true;
            }

            const label = isDisabled ? 'Need Approval' : 'Send to Client';
            setSendToClientDisabled(isDisabled);
            setSendToClientLabel(label);
        }
    }, [proposalData, approvalStatus]);
    const handleBack = () => {
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate('/proposals');
        }
    };

    const handleNavigateToLeadDetail = (leadId) => {
        navigate(`/leads/detail/${leadId}`);
    };

    const handleNavigateToProjectDetail = (leadId) => {
        navigate(`/projects/detail/${leadId}`);
    };
    const handlePreview = () => {
        navigate(`/proposals/${id}/preview`);
    };
    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
        // Automatically load document when switching to Proposal View tab
        if (tabId === 'tabs-proposal-view' && proposalData && !filledDocumentUrl && !loadingDocument) {
            if (proposalData.proposalPdfFillPdf || proposalData.proposalPdfFill) {
                downloadAndDisplayFilledDocument();
            }
        }
    };
    // Fetch company data by companyId
    const fetchCompanyData = async (companyId) => {
        try {
            const response = await api.get(`/crm/companies/${companyId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching company data:', error);
            return null;
        }
    };

    // Allow filling in NPWP directly from the "Cannot Convert to Project" modal
    const handleSaveNpwpAndContinue = async () => {
        const trimmedNpwp = npwpInputValue.trim();
        if (!trimmedNpwp) {
            setAlert({
                type: 'warning',
                message: 'Please enter a Company Tax Number (NPWP) before continuing.'
            });
            return;
        }
        if (!npwpValidationCompanyId) {
            setAlert({
                type: 'danger',
                message: 'Cannot save NPWP: Company could not be identified.'
            });
            return;
        }

        setIsSavingNpwp(true);
        try {
            // Fetch the same shape the real Company edit form uses (/md/companies/{id} returns
            // { company, contacts } separately) — PUTting a company object built from a different
            // endpoint's shape makes the backend think contacts were removed and blocks it with an
            // FK constraint error.
            const detailRes = await api.get(`/md/companies/${npwpValidationCompanyId}`);
            const freshCompany = detailRes.data?.company ?? {};
            const contacts = Array.isArray(detailRes.data?.contacts) ? detailRes.data.contacts : [];
            const taggingIds = Array.isArray(freshCompany.taggingIds)
                ? freshCompany.taggingIds.map((tid) => Number(tid)).filter((n) => !isNaN(n))
                : [];

            const updatedCompany = { ...freshCompany, contacts, taggingIds, npwp: trimmedNpwp };
            await api.put(`/md/companies/${npwpValidationCompanyId}`, updatedCompany);

            setCompanyData(updatedCompany);
            setShowNpwpValidationModal(false);
            setAlert({
                type: 'success',
                message: 'Company Tax Number (NPWP) saved successfully.'
            });
            // Proceed straight to the conversion confirmation
            setShowConvertToProjectModal(true);
        } catch (error) {
            console.error('Error saving NPWP:', error);
            setAlert({
                type: 'danger',
                message: 'Failed to save NPWP: ' + (error.response?.data?.message || error.message)
            });
        } finally {
            setIsSavingNpwp(false);
        }
    };

    const handleConvertToProject = async (e) => {
        if (e && e.preventDefault) e.preventDefault();

        // Prevent multiple clicks during validation
        if (isValidatingNpwp) {
            return;
        }

        // Check if data is still loading
        if (!proposalData || loading || !leadData) {
            setAlert({
                type: 'warning',
                message: 'Please wait for proposal data to load before converting.'
            });
            return;
        }

        // Check if already converted
        if (projectStatus === 'Converted') {
            setAlert({
                type: 'info',
                message: 'This proposal has already been converted to a project.'
            });
            return;
        }

        // Validate that Proposal Status must be 'Accepted' (code 3)
        const currentStatusProposal = proposalData?.statusProposal;
        const currentStatusProposalDesc = proposalData?.statusProposalDesc;

        if (currentStatusProposal !== 3) {
            setAlert({
                type: 'warning',
                message: `Cannot convert to project: Proposal status must be 'Accepted' (current status: ${currentStatusProposalDesc || currentStatusProposal}). Only proposals with 'Accepted' status can be converted to projects.`
            });
            return;
        }

        // Validate Audit Methodology for Certification Program / Sustainability services
        const hasCertOrSustainability = (proposalData?.proposal_sections || []).some(section => {
            const name = (section.type || '').toLowerCase();
            return name.includes('certification') || name.includes('sustainability');
        });
        if (hasCertOrSustainability) {
            const methodologyValue = proposalData?.auditMethodology || proposalData?.methodology;
            const auditMethodologyFilled = methodologyValue && methodologyValue.trim() !== '';
            if (!auditMethodologyFilled) {
                setAlert({
                    type: 'warning',
                    message: 'Proposal ini memiliki layanan Certification Program / Sustainability. Wajib mengisi Audit Methodology (termasuk Site Location) sebelum convert ke project. Anda akan diarahkan ke halaman Edit Proposal.'
                });
                setTimeout(() => navigate(`/proposals/edit/${id}`), 2500);
                return;
            }
        }

        // ✅ TAMBAHAN: Validasi NPWP - Check if company has NPWP (Tax Number)
        // Be more careful about which IDs are actual company IDs vs other types of IDs
        const validationCompanyId = companyId || // This should be set from fixedData.client?.id
            proposalData?.companyId || // Direct company ID from proposal
            leadData?.companyId || // Company ID from lead data
            leadData?.company?.id; // Company ID from lead's company object

        // Don't use proposalData?.client?.companyId or proposalData?.client?.id as these might be client IDs, not company IDs

        if (validationCompanyId) {
            setIsValidatingNpwp(true);
            try {
                const companyData = await fetchCompanyData(validationCompanyId);
                setCompanyData(companyData);

                // Check if NPWP is empty or null
                const npwp = companyData?.npwp;

                if (!npwp || npwp.trim() === '') {
                    setAlert({
                        type: 'warning',
                        message: 'Company Tax Number (NPWP) is required for project conversion.'
                    });
                    // Show NPWP validation modal instead of proceeding
                    setNpwpValidationCompanyId(validationCompanyId);
                    setNpwpInputValue('');
                    setShowNpwpValidationModal(true);
                    setIsValidatingNpwp(false);
                    return;
                }

                // If NPWP is valid, proceed to conversion modal
                setShowConvertToProjectModal(true);
                setIsValidatingNpwp(false);
            } catch (error) {
                console.error('Error fetching company data for NPWP validation:', error);
                // If we can't fetch company data, show warning but allow conversion
                setAlert({
                    type: 'warning',
                    message: 'Could not verify company tax information. Proceeding with conversion...'
                });
                setShowConvertToProjectModal(true);
                setIsValidatingNpwp(false);
            }
        } else {
            // If no companyId, proceed to conversion modal
            setShowConvertToProjectModal(true);
        }
    };
    // Function to confirm convert to project
    const confirmConvertToProject = async () => {
        // ✅ PERBAIKAN: Prevent concurrent calls
        if (isConvertingProject) {
            console.warn('Convert already in progress, ignoring duplicate call');
            return;
        }

        // ✅ FINAL NPWP VALIDATION: Double-check NPWP before conversion
        const finalCompanyId = companyId || proposalData?.companyId || leadData?.companyId || leadData?.company?.id;
        if (finalCompanyId) {
            try {
                const companyData = await fetchCompanyData(finalCompanyId);
                const npwp = companyData?.npwp;

                if (!npwp || npwp.trim() === '') {
                    setAlert({
                        type: 'danger',
                        message: 'Cannot convert: Company Tax Number (NPWP) is required. Please update the company information first.'
                    });
                    setShowConvertToProjectModal(false);
                    return;
                }
            } catch (error) {
                console.error('Error during final NPWP validation:', error);
                setAlert({
                    type: 'warning',
                    message: 'Could not verify company tax information. Proceeding with conversion...'
                });
            }
        }

        try {
            setIsConvertingProject(true);
            // Show loading alert immediately
            setAlert({
                type: 'info',
                message: 'Converting proposal to project... Please wait.'
            });
            // Resolve proposalId (detail endpoint already provided it)
            let proposalId = proposalData?.id;
            if (!proposalId && id) {
                try {
                    const resId = await api.get(`/crm/proposals/id-by-lead/${id}`);
                    proposalId = typeof resId.data === 'object' ? resId.data.id : resId.data;
                } catch (e2) {
                    console.error('Failed to resolve proposalId by leadId:', e2);
                }
            }
            if (!proposalId) {
                console.error('No proposalId found');
                setAlert({ type: 'danger', message: 'Cannot convert: proposalId not found.' });
                return;
            }

            // ✅ TAMBAHAN: Fetch fresh proposal detail to ensure complete data (like list page does)
            let proposalDetailData = null;
            let proposalListData = null;

            try {
                // Fetch from detail endpoint for proposal_sections
                const detailRes = await api.get(`/crm/proposals/detail/lead/${id}`);
                proposalDetailData = detailRes.data;

                // ✅ TAMBAHAN: Also fetch from list endpoint to get partnerType and other fields
                // This is critical because the list endpoint returns partnerType which detail endpoint might not
                try {
                    // The list endpoint is paginated ({ content, ... }); narrow it to this proposal's
                    // code so the match does not depend on the proposal being on the first page.
                    const listRes = await api.get('/crm/proposals', {
                        params: { search: proposalDetailData?.proposal_number || proposalData?.proposal_number || undefined, size: 100 }
                    });
                    const allProposals = Array.isArray(listRes.data)
                        ? listRes.data
                        : (Array.isArray(listRes.data?.content) ? listRes.data.content : []);
                    // Find this specific proposal by leadId (same as list page uses itemToConvert.leadId)
                    proposalListData = allProposals.find(p =>
                        p.leadId === parseInt(id) ||
                        p.id === proposalId ||
                        (proposalDetailData?.leadId && p.leadId === parseInt(proposalDetailData.leadId))
                    );

                    if (proposalListData) {
                    } else {
                        console.warn('⚠️ Proposal not found in list endpoint. Searched for leadId:', id, 'or proposalId:', proposalId);
                        console.warn('⚠️ Available proposals leadIds:', allProposals.map(p => p.leadId).slice(0, 5));
                    }
                } catch (listError) {
                    console.error('❌ Failed to fetch from list endpoint:', listError);
                    // Don't fail the conversion if list fetch fails, but log it
                }
            } catch (detailError) {
                console.error('Failed to fetch proposal detail:', detailError);
                setAlert({ type: 'danger', message: 'Cannot convert: Failed to fetch proposal details.' });
                return;
            }

            // Validate proposal_sections
            if (!proposalDetailData?.proposal_sections || proposalDetailData.proposal_sections.length === 0) {
                setAlert({ type: 'danger', message: 'Cannot convert: No proposal sections found.' });
                return;
            }

            // ✅ Extract partner type - prioritize list data which has complete info (same as list page)
            // The list page uses: proposalDetailData?.partnerType || itemToConvert.partnerType || null
            // Since itemToConvert in list page comes from list data, we prioritize proposalListData here
            const extractedPartnerType = proposalListData?.partnerType ||
                proposalListData?.partner_type ||
                proposalDetailData?.partnerType ||
                proposalDetailData?.partner_type ||
                proposalData?.partnerType ||
                proposalData?.partner_type ||
                proposalDetailData?.client?.partnerType ||
                proposalDetailData?.client?.partner_type ||
                null;

            // Build payload with more complete data (merge list + detail data with proper fallbacks)
            // ✅ FIX: Use same extraction pattern as list page for consistency
            const payload = {
                leadId: proposalDetailData?.leadId || proposalListData?.leadId || id,
                companyName: proposalDetailData?.client?.name || proposalListData?.companyName,
                projectDate: proposalDetailData?.dates?.proposal_date || proposalListData?.proposalDate || null,
                validUntil: proposalDetailData?.dates?.valid_until || proposalListData?.validUntil || null,
                partnerType: extractedPartnerType,
                grandTotal: proposalDetailData?.grandTotal ?? proposalListData?.grandTotal ?? 0,
                statusDesc: 'Draft',
                status: 1,
                // Template and assignment info
                projectTemplateId: proposalDetailData?.template?.id || null,
                assignedTo: proposalDetailData?.assigned_to?.name || null,
                team: proposalDetailData?.assigned_to?.team || null,
                // ✅ AUDIT METHODOLOGY & MULTI-SITE: Include in payload for project conversion
                auditMethodology: proposalDetailData?.auditMethodology || proposalData?.auditMethodology || null,
                numberOfSites: proposalDetailData?.numberOfSites || proposalData?.numberOfSites || null,
                multiSite: proposalDetailData?.multiSite || proposalData?.multiSite || false,
                // Project services mapping from proposal sections with ID as number
                projectServices: proposalDetailData?.proposal_sections?.map((section, sectionIdx) => {
                    const mappedSection = {
                        serviceId: parseInt(section.serviceId) || null, // Convert to number
                        serviceName: section.type || 'Service',
                        standards: section.services?.map((service, serviceIdx) => {
                            // ✅ FIX: Extract parent serviceItemId - backend now includes serviceItemId in response
                            // Priority: serviceItemId (new field) > service_item_id > fallback to child > default
                            let parentServiceItemId = parseInt(
                                service.serviceItemId ||  // ✅ NEW: Backend now returns this field
                                service.service_item_id ||
                                service.serviceItem?.id ||
                                service.service_item?.id
                            ) || null;

                            // ✅ FIX: If parent doesn't have serviceItemId, try to get it from the first child (fallback)
                            if (!parentServiceItemId && service.sub_services && service.sub_services.length > 0) {
                                parentServiceItemId = parseInt(
                                    service.sub_services[0].serviceItemId ||
                                    service.sub_services[0].service_item_id
                                ) || null;
                                if (parentServiceItemId) {
                                    console.warn('⚠️ Using child serviceItemId for parent (parent should have its own):', parentServiceItemId);
                                }
                            }

                            // ✅ FIX: Default to 1 if still null (same as EditProject line 657: `|| 1`)
                            // This ensures the parent standard is always saved with a valid serviceItemId
                            if (!parentServiceItemId) {
                                console.error('❌ CRITICAL: Parent serviceItemId is missing! Using default 1. This will cause the parent to appear empty when editing.');
                                parentServiceItemId = 1; // Default fallback to ensure parent is saved
                            }

                            // ✅ FIX: Extract parent productCategoryId - backend now includes productCategoryId in response
                            let parentProductCategoryId = parseInt(
                                service.productCategoryId ||  // ✅ NEW: Backend now returns this field
                                service.product_category_id
                            ) || null;

                            if (!parentProductCategoryId) {
                                console.warn('⚠️ Parent productCategoryId not found, using default 1');
                                parentProductCategoryId = 1;
                            }

                            const mappedService = {
                                // EA Code / Scope / Mandays on Audit Process source from the proposal
                                // via this FK -- DetailProposal's convert payload used to omit it
                                // entirely (unlike Proposals/index.jsx's own convert flow), so every
                                // project converted from here permanently lost the link back to its
                                // proposal_standard_items row.
                                proposalStandardItemId: service.proposalStandardItemId || null,
                                standardId: parseInt(service.standardId) || 1, // ✅ FIX: Default to 1 instead of null
                                standardName: service.standard || 'Standard',
                                productCategoryId: parentProductCategoryId, // ✅ FIX: Use extracted productCategoryId (never null)
                                productCategoryName: service.product_type || 'Product Category',
                                serviceItemId: parentServiceItemId, // ✅ FIX: Use the fixed parentServiceItemId (never null)
                                serviceItemName: service.service_item || 'Service Item',
                                yearType: service.yearType || 0,
                                selectedYear: service.selectedYear || new Date().getFullYear(),
                                qty: service.qty || service.quantity || 1,
                                unit: service.unit || 'Unit',
                                unitPrice: service.unitPrice || 0,
                                workflowIdSystem: service.workflowIdSystem || null,
                                workflowIdChoice: service.workflowIdChoice || null,
                                // Children mapping from sub_services with ID as number
                                children: service.sub_services?.map((subService, subIdx) => {
                                    return {
                                        proposalStandardItemId: subService.proposalStandardItemId || null,
                                        standardId: parseInt(subService.standardId) || parseInt(service.standardId) || 1, // ✅ FIX: Use parent's standardId as fallback
                                        standardName: subService.standard || service.standard || 'Standard', // ✅ FIX: Use parent's standardName as fallback
                                        productCategoryId: parseInt(subService.productCategoryId) || 1, // ✅ FIX: Default to 1 instead of null
                                        productCategoryName: subService.product_type || 'Product Category',
                                        serviceItemId: parseInt(subService.serviceItemId || subService.service_item_id || subService.id) || 1, // ✅ FIX: Default to 1 instead of null
                                        serviceItemName: subService.service_item || 'Service Item',
                                        yearType: subService.yearType || 0,
                                        selectedYear: subService.selectedYear || new Date().getFullYear(),
                                        qty: subService.qty || subService.quantity || 1,
                                        unit: subService.unit || 'Unit',
                                        unitPrice: subService.unitPrice || 0,
                                        workflowIdSystem: subService.workflowIdSystem || null,
                                        workflowIdChoice: subService.workflowIdChoice || null
                                    };
                                }) || []
                            };
                            return mappedService;
                        }) || []
                    };
                    return mappedSection;
                }) || []
            };

            // Validate projectServices before sending
            if (!payload.projectServices || payload.projectServices.length === 0) {
                setAlert({ type: 'danger', message: 'Cannot convert: No project services found in payload.' });
                return;
            }
            // Validate that each service has standards
            const hasValidServices = payload.projectServices.every(service => {
                const hasStandards = service.standards && service.standards.length > 0;
                if (!hasStandards) {
                    console.warn('Service without standards:', service);
                }
                return hasStandards;
            });
            if (!hasValidServices) {
                setAlert({ type: 'danger', message: 'Cannot convert: Some services do not have standards.' });
                return;
            }
            // Validate that each standard has required fields
            const hasValidStandards = payload.projectServices.every(service => {
                return service.standards.every(standard => {
                    const hasRequiredFields = standard.standardId && standard.serviceItemId;
                    if (!hasRequiredFields) {
                        console.warn('Standard missing required fields:', standard);
                        console.warn('standardId:', standard.standardId);
                        console.warn('serviceItemId:', standard.serviceItemId);
                    }
                    return hasRequiredFields;
                });
            });
            // More flexible validation with fallback values
            // Add fallback values for services that don't have serviceId
            payload.projectServices = payload.projectServices.map((service, idx) => {
                // If serviceId doesn't exist, use fallback based on serviceName
                if (!service.serviceId || service.serviceId === null || service.serviceId === undefined) {
                    if (service.serviceName) {
                        // Mapping based on serviceName
                        const serviceNameMapping = {
                            'Training': 1,
                            'Certification Program': 2,
                            'Certification': 2,
                            'Audit': 3,
                            'Tes Services': 7,
                            'ISCC': 8
                        };
                        service.serviceId = serviceNameMapping[service.serviceName] || 1; // Default to 1
                    } else {
                        service.serviceId = 1; // Default fallback
                    }
                }
                // If serviceName doesn't exist, use fallback
                if (!service.serviceName || service.serviceName.trim() === '') {
                    service.serviceName = 'Service';
                }
                return service;
            });
            // Simpler validation - just check if there are services
            const hasValidServiceData = payload.projectServices && payload.projectServices.length > 0;
            if (!hasValidServiceData) {
                setAlert({ type: 'danger', message: 'Cannot convert: No project services found in payload.' });
                return;
            }


            // ✅ VALIDATION: Ensure partnerType is included (same check as list page)
            if (!payload.partnerType) {
                console.error('❌ WARNING: partnerType is missing from payload!', {
                    proposalListData: proposalListData?.partnerType || proposalListData?.partner_type,
                    proposalDetailData: proposalDetailData?.partnerType || proposalDetailData?.partner_type,
                    proposalData: proposalData?.partnerType || proposalData?.partner_type
                });
                // Don't block conversion, but log the issue for debugging
            }

            const res = await api.post(`/crm/projects/convert-from-proposal/${proposalId}`, payload);

            // Update project status to Converted
            setProjectStatus('Converted');

            const leadIdForDetail = res?.data?.leadId ?? proposalDetailData?.leadId ?? id;
            const alreadyExists = res?.data?.alreadyExists;

            // ✅ TAMBAHAN: Update proposal stage to WON if not already WON
            const currentProposalStageId = proposalData?.proposalStageId || proposalDetailData?.proposalStageId;

            // Find WON stage from proposal stages
            const wonStage = proposalStages?.find(stage =>
                stage.name && stage.name.toUpperCase().includes('WON')
            );

            // Check if current stage is already WON
            const isAlreadyWon = wonStage && currentProposalStageId &&
                parseInt(currentProposalStageId) === parseInt(wonStage.id);

            // Update stage to WON if not already WON
            if (wonStage && !isAlreadyWon && leadIdForDetail) {
                try {
                    await api.put(`/crm/proposals/${leadIdForDetail}/update-stage`, {
                        proposalStageId: wonStage.id
                    });
                } catch (stageError) {
                    console.warn('⚠️ Failed to update proposal stage to WON:', stageError);
                    // Don't block navigation if stage update fails
                }
            }

            if (leadIdForDetail) {
                // Replace loading alert with appropriate message
                if (alreadyExists) {
                    setAlert({
                        type: 'info',
                        message: `Project already exists for this proposal. Redirecting to project detail...`
                    });
                } else {
                    setAlert({
                        type: 'success',
                        message: 'Proposal converted to project successfully!'
                    });
                }
                navigate(`/projects/detail/${leadIdForDetail}`);
            }
        } catch (error) {
            console.error('Error converting to project:', error);
            // If backend signals audit methodology is required, redirect to edit proposal
            if (error.response?.data?.requiresAuditMethodology) {
                setAlert({
                    type: 'warning',
                    message: error.response.data.message || 'Audit Methodology wajib diisi. Mengarahkan ke Edit Proposal...'
                });
                setTimeout(() => navigate(`/proposals/edit/${id}`), 2500);
                setIsConvertingProject(false);
                setShowConvertToProjectModal(false);
                return;
            }
            // Enhanced error handling to provide more informative messages
            const errorMessage = error.response?.data?.message ||
                error.response?.data?.error ||
                error.message ||
                'Failed to convert proposal to project';
            console.error('Detailed convert to project error:', {
                message: errorMessage,
                status: error.response?.status,
                statusText: error.response?.statusText,
                data: error.response?.data,
                fullError: error
            });
            // Replace loading alert with error message
            setAlert({
                type: 'danger',
                message: `Convert to project failed: ${errorMessage}`
            });
        } finally {
            setIsConvertingProject(false);
        }
    };
    const handleDownloadPDF = async () => {
        try {
            // Check if PDF document is available
            if (!proposalData.proposalPdfFillPdf) {
                setAlert({
                    type: 'warning',
                    message: 'PDF document is not available yet. Please wait for the document to be generated.'
                });
                return;
            }
            // Show loading state
            setAlert({
                type: 'info',
                message: 'Downloading PDF document...'
            });
            // Download the PDF document
            const response = await api.get(`/crm/proposals/${proposalData.id}/download-filled-document-pdf`, {
                responseType: 'blob'
            });
            // Create download link
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `proposal_${proposalData.proposal_number}_${proposalData.id}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            // Show success message
            setAlert({
                type: 'success',
                message: 'PDF document downloaded successfully!'
            });
        } catch (error) {
            console.error('Error downloading PDF:', error);
            // Enhanced error handling to provide more informative messages
            const errorMessage = error.response?.data?.message ||
                error.response?.data?.error ||
                error.message ||
                'Failed to download PDF document';
            console.error('Detailed download PDF error:', {
                message: errorMessage,
                status: error.response?.status,
                statusText: error.response?.statusText,
                data: error.response?.data,
                fullError: error
            });
            setAlert({
                type: 'danger',
                message: `Download PDF failed: ${errorMessage}`
            });
        }
    };
    // Handle Accept Proposal - Update status to Accepted
    const handleAcceptProposal = () => {
        setShowAcceptProposalModal(true);
    };
    // ✅ Accept Proposal - Same implementation as ProposalPreview
    const confirmAcceptProposal = async () => {
        // Prevent multiple clicks
        if (isAcceptingProposal) {
            return;
        }
        setIsAcceptingProposal(true);
        try {
            if (!proposalData?.id) throw new Error('Proposal ID not found');

            // Try to get the leadId from various possible sources
            // Prioritize URL parameter (id) since it's always the leadId
            let endpointId = id || proposalData.leadId || proposalData.lead_id || proposalData.lead?.id;

            if (!endpointId) {
                throw new Error('No valid ID found for the proposal. Cannot proceed with status update.');
            }

            // Ensure endpointId is a string or number
            endpointId = String(endpointId);

            // Same payload as ProposalPreview
            await api.put(`/crm/proposals/${endpointId}/update-status-no-workflow`, {
                status: 2, // Approved
                statusDesc: "Approved",
                statusProposal: 3, // Accepted
                statusProposalDesc: "Accepted"
            });

            setAlert({
                type: 'success',
                message: 'Proposal accepted successfully'
            });

            // Close modal
            setShowAcceptProposalModal(false);

            // Refresh proposal data to get updated status (same as ProposalPreview)
            try {
                const refreshedRes = await api.get(`/crm/proposals/detail/lead/${endpointId}`);
                if (refreshedRes.data) {
                    // Format status descriptions to proper case
                    const fixedData = {
                        ...refreshedRes.data,
                        statusDesc: formatStatusDesc(refreshedRes.data.statusDesc),
                        statusApproval: formatStatusDesc(refreshedRes.data.statusApproval || refreshedRes.data.statusDesc),
                        statusProposalDesc: formatStatusDesc(refreshedRes.data.statusProposalDesc)
                    };
                    setProposalData(fixedData);
                }
            } catch (refreshError) {
                console.warn('⚠️ Failed to refresh proposal data:', refreshError);
                // Fallback: Update local state
                setProposalData(prev => prev ? {
                    ...prev,
                    statusProposalDesc: 'Accepted',
                    statusProposal: 3
                } : prev);
            }
        } catch (error) {
            console.error('Error accepting proposal:', error);
            const errorMessage = error.response?.data?.message ||
                error.response?.data?.error ||
                error.message ||
                'Failed to accept proposal';
            setAlert({
                type: 'danger',
                message: `Failed to accept proposal: ${errorMessage}`
            });
        } finally {
            setIsAcceptingProposal(false);
        }
    };
    // Function to download and display filled document
    const downloadAndDisplayFilledDocument = async () => {
        // Check if proposalData exists before proceeding
        if (!proposalData || !proposalData.id) {
            console.warn('Cannot download document: proposalData is not available');
            setDocumentError('Proposal data is not available yet.');
            return;
        }

        setLoadingDocument(true);
        setDocumentError(null);
        try {
            let endpoint, contentType;
            if (proposalData.proposalPdfFillPdf) {
                endpoint = `crm/proposals/${proposalData.id}/download-filled-document-pdf`;
                contentType = 'application/pdf';
            } else if (proposalData.proposalPdfFill) {
                endpoint = `crm/proposals/${proposalData.id}/download-filled-document`;
                contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            } else {
                setDocumentError('No filled document available.');
                setLoadingDocument(false);
                return;
            }
            const response = await api.get(endpoint, { responseType: 'blob' });
            const url = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
            setFilledDocumentUrl(url);
            setShowDocument(true);
        } catch (error) {
            console.error('Error in downloadAndDisplayFilledDocument:', error);
            setDocumentError(`Failed to load document: ${error.message}`);
        } finally {
            setLoadingDocument(false);
        }
    };
    const handleDownloadDocument = () => {
        if (filledDocumentUrl) {
            const link = document.createElement('a');
            link.href = filledDocumentUrl;
            // Determine file extension based on available document type
            let fileName;
            if (proposalData.proposalPdfFillPdf) {
                fileName = `proposal_${proposalData.id}_filled.pdf`;
            } else if (proposalData.proposalPdfFill) {
                fileName = `proposal_${proposalData.id}_filled.docx`;
            } else {
                fileName = `proposal_${proposalData.id}_filled`;
            }
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
    };
    const handleCloseDocument = () => {
        setShowDocument(false);
        if (filledDocumentUrl) {
            window.URL.revokeObjectURL(filledDocumentUrl);
            setFilledDocumentUrl(null);
        }
    };
    // ✅ MODIFIKASI: Function to send email to pembuat proposal (not client)
    // Parameter clientEmail diganti menjadi emailPembuat
    const sendProposalEmailToClient = async (clientEmail, emailSettings, emailTemplates, proposalData) => {
        try {
            // Helper: format dates as dd/mm/yyyy
            const formatDateToDDMMYYYY = (value) => {
                if (!value) return '';
                const d = new Date(value);
                if (Number.isNaN(d.getTime())) return value;
                const dd = String(d.getDate()).padStart(2, '0');
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const yyyy = d.getFullYear();
                return `${dd}/${mm}/${yyyy}`;
            };
            // Debug proposal data str8ucture
            // Check if PDF file exists - try different possible field names
            let pdfFilePath = null;
            // ✅ TAMBAHAN: Refresh proposal data untuk mendapatkan PDF terbaru
            try {
                const proposalId = await getProposalId(id);
                if (proposalId) {
                    const detailRes = await api.get(`crm/proposals/${proposalId}`);
                    const refreshedProposalData = detailRes.data;
                    // ✅ TAMBAHAN: Pastikan data lengkap sebelum update state
                    if (refreshedProposalData &&
                        refreshedProposalData.client &&
                        refreshedProposalData.template &&
                        refreshedProposalData.assigned_to &&
                        refreshedProposalData.proposal_sections &&
                        Array.isArray(refreshedProposalData.proposal_sections)) {
                        // Update proposalData dengan data terbaru - format status descriptions
                        const fixedData = {
                            ...refreshedProposalData,
                            statusDesc: formatStatusDesc(refreshedProposalData.statusDesc),
                            statusApproval: formatStatusDesc(refreshedProposalData.statusApproval || refreshedProposalData.statusDesc),
                            statusProposalDesc: formatStatusDesc(refreshedProposalData.statusProposalDesc)
                        };
                        setProposalData(fixedData);
                    } else {
                        console.warn('⚠️ Refreshed data incomplete, skipping state update');

                    }
                    // Cek PDF dengan data terbaru
                    if (refreshedProposalData.proposal_pdf_fill_pdf) {
                        pdfFilePath = refreshedProposalData.proposal_pdf_fill_pdf;
                    } else if (refreshedProposalData.proposalPdfFillPdf) {
                        pdfFilePath = refreshedProposalData.proposalPdfFillPdf;
                    } else if (refreshedProposalData.pdf_fill_path) {
                        pdfFilePath = refreshedProposalData.pdf_fill_path;
                    } else if (refreshedProposalData.pdfPath) {
                        pdfFilePath = refreshedProposalData.pdfPath;
                    }
                }
            } catch (refreshError) {
                console.warn('Could not refresh proposal data:', refreshError);
            }
            // Fallback ke data yang ada jika refresh gagal
            if (!pdfFilePath) {
                if (proposalData.proposal_pdf_fill_pdf) {
                    pdfFilePath = proposalData.proposal_pdf_fill_pdf;
                } else if (proposalData.proposalPdfFillPdf) {
                    pdfFilePath = proposalData.proposalPdfFillPdf;
                } else if (proposalData.pdf_fill_path) {
                    pdfFilePath = proposalData.pdf_fill_path;
                } else if (proposalData.pdfPath) {
                    pdfFilePath = proposalData.pdfPath;
                }
            }
            // If no PDF path found, try to send email without attachment
            if (!pdfFilePath) {
                // Get email template
                let emailTemplate = null;
                if (Array.isArray(emailTemplates) && emailTemplates.length > 0) {
                    // Fix: Look for templateId instead of type
                    emailTemplate = emailTemplates.find(template =>
                        template.templateId === 'proposal' ||
                        template.id === 'proposal'
                    );
                    if (emailTemplate) {

                    }
                }
                // Prepare email content
                let subject = `Proposal ${proposalData.proposal_number} - ${proposalData.client?.company_name || 'Client'}`;
                let message = `Dear ${proposalData.client?.company_name || 'Client'},\n\nThank you for your interest in our services. Please find attached our proposal for your review.\n\nWe look forward to working with you.\n\nBest regards,\nYour Company Team`;
                // Use template if available
                if (emailTemplate) {
                    subject = emailTemplate.subject || subject;
                    let templateContent = emailTemplate.content || message;
                    // Replace placeholders with actual data
                    templateContent = templateContent
                        .replace(/\{\{client_name\}\}/g, leadData?.pic || proposalData.client?.name || 'Client')
                        .replace(/\{\{proposal_code\}\}/g, proposalData.proposal_number || '')
                        .replace(/\{\{company_name\}\}/g, proposalData.client?.name || '')
                        .replace(/\{\{amount\}\}/g, proposalData.grandTotal ? `Rp ${proposalData.grandTotal.toLocaleString()}` : 'Rp 0')
                        .replace(/\{\{valid_until\}\}/g, formatDateToDDMMYYYY(proposalData.dates?.valid_until) || 'TBD')
                        .replace(/\{\{proposal_date\}\}/g, formatDateToDDMMYYYY(proposalData.dates?.proposal_date));
                    message = templateContent;

                }
                // Prepare email data without attachment
                const emailData = {
                    to: clientEmail,
                    subject: subject,
                    message: message,
                    proposalId: proposalData.id,
                    includeAttachment: false // Set to false since no PDF
                };
                // 
                const result = await sendProposalEmail(emailData);
                return result;
            }
            // If PDF path exists, proceed with attachment
            // Get email template
            let emailTemplate = null;
            if (Array.isArray(emailTemplates) && emailTemplates.length > 0) {
                // Fix: Use same logic as the no-PDF case
                emailTemplate = emailTemplates.find(template =>
                    template.templateId === 'proposal' ||
                    template.id === 'proposal'
                );
                if (emailTemplate) {

                } else {

                }
            }
            // Prepare email content
            let subject = `Proposal ${proposalData.proposal_number} - ${proposalData.client?.company_name || 'Client'}`;
            let message = `Dear ${proposalData.client?.company_name || 'Client'},\n\nThank you for your interest in our services. Please find attached our proposal for your review.\n\nWe look forward to working with you.\n\nBest regards,\nYour Company Team`;
            // Use template if available
            if (emailTemplate) {
                subject = emailTemplate.subject || subject;
                let templateContent = emailTemplate.content || message;
                // Debug: Log proposal data structure

                // Replace placeholders with actual data - with better fallbacks
                templateContent = templateContent
                    .replace(/\{\{client_name\}\}/g, leadData?.pic || proposalData.client?.name || proposalData.client?.company_name || 'Client')
                    .replace(/\{\{proposal_code\}\}/g, proposalData.proposal_number || '')
                    .replace(/\{\{company_name\}\}/g, proposalData.client?.name || proposalData.client?.company_name || 'N/A')
                    .replace(/\{\{amount\}\}/g, proposalData.grandTotal ? `Rp ${proposalData.grandTotal.toLocaleString()}` : 'Rp 0')
                    .replace(/\{\{valid_until\}\}/g, formatDateToDDMMYYYY(proposalData.dates?.valid_until) || 'TBD')
                    .replace(/\{\{proposal_date\}\}/g, formatDateToDDMMYYYY(proposalData.dates?.proposal_date));
                message = templateContent;

            }
            // Prepare email data with attachment
            const emailData = {
                to: clientEmail,
                subject: subject,
                message: message,
                proposalId: proposalData.id,
                includeAttachment: true
            };
            // 
            const result = await sendProposalEmail(emailData);
            return result;
        } catch (error) {
            console.error('✗ Error sending proposal email:', error);
            throw error;
        }
    };
    // Fetch investment breakdown from API.
    // Accepts an optional proposalOverride so callers can use freshly loaded
    // proposal data before React commits the state update.
    const fetchInvestmentBreakdown = async (proposalOverride) => {
        try {
            const response = await api.get(`/crm/proposals/${id}/breakdown`);
            const data = response.data;
            if (!data || !data.breakdown) {
                setShowBreakdown(false);
                setInvestmentBreakdown(null);
                return;
            }
            // Use the exchange-rate snapshot stored on this proposal. This
            // keeps the detail total stable even when the currency-rate table
            // is updated after the proposal was created.
            const proposal = proposalOverride || proposalData;
            const proposalRate = Number(proposal?.exchangeRateAtCreation);
            const exchangeRate = Number.isFinite(proposalRate) && proposalRate > 0 ? proposalRate : 1;

            // Recompute each item's converted amount using the proposal-level
            // snapshot instead of reading the current/historical rate table.
            (data.breakdown || []).forEach(serviceRow => {
                (serviceRow.standards || []).forEach(stdRow => {
                    (stdRow.serviceItems || []).forEach(item => {
                        const currencyCode = item.currencyCode || 'IDR';
                        const unitPrice = item.unitPrice != null ? Number(item.unitPrice) : 0;
                        const qty = item.qty != null ? Number(item.qty) : 1;
                        const rawAmount = unitPrice * qty;
                        const rate = currencyCode !== 'IDR' ? exchangeRate : 1;
                        const convertedAmount = currencyCode !== 'IDR' ? rawAmount * rate : rawAmount;
                        const yearCount = Array.isArray(item.years) ? item.years.length
                            : (Array.isArray(item.prices) ? item.prices.length : 1);
                        item.currencyCode = currencyCode;
                        item.exchangeRate = rate;
                        item.unitPrice = unitPrice;
                        item.qty = qty;
                        item.prices = Array.from({ length: yearCount }, () => convertedAmount);
                    });
                });
            });

            let years = Array.isArray(data.years) ? data.years : [];
            let totals = Array.isArray(data.totals) ? data.totals : [];

            // If backend returned no years, derive them from the item data
            if (years.length === 0) {
                const allYearsSet = new Set();
                const totalsByYear = {};
                (data.breakdown || []).forEach(serviceRow => {
                    (serviceRow.standards || []).forEach(stdRow => {
                        (stdRow.serviceItems || []).forEach(item => {
                            const itemYears = Array.isArray(item.years) ? item.years : [];
                            const itemPrice = Array.isArray(item.prices) && item.prices.length > 0 ? Number(item.prices[0]) : 0;
                            itemYears.forEach(y => {
                                allYearsSet.add(y);
                                totalsByYear[y] = (totalsByYear[y] || 0) + itemPrice;
                            });
                        });
                    });
                });

                // Fallback: if items have no years either, use current year
                if (allYearsSet.size === 0) {
                    allYearsSet.add(new Date().getFullYear());
                    // distribute grandTotal across items for the fallback year
                    const fallbackYear = new Date().getFullYear();
                    const gt = proposalData?.grandTotal || 0;
                    totalsByYear[fallbackYear] = gt;
                    // assign the grandTotal price to every item so they show something
                    let firstItem = true;
                    (data.breakdown || []).forEach(serviceRow => {
                        (serviceRow.standards || []).forEach(stdRow => {
                            (stdRow.serviceItems || []).forEach(item => {
                                item.years = [fallbackYear];
                                item.prices = firstItem ? [gt] : [0];
                                firstItem = false;
                            });
                        });
                    });
                }

                years = Array.from(allYearsSet).sort((a, b) => a - b);
                totals = years.map(y => totalsByYear[y] || 0);
            }

            // Always recompute totals from the (now live-rate-converted) item
            // prices rather than trusting data.totals, which the backend computes
            // from the same stale per-row conversion this recompute is replacing.
            const totalsByYearFinal = {};
            (data.breakdown || []).forEach(serviceRow => {
                (serviceRow.standards || []).forEach(stdRow => {
                    (stdRow.serviceItems || []).forEach(item => {
                        (item.years || []).forEach((y, idx) => {
                            const amount = Array.isArray(item.prices) ? Number(item.prices[idx] || 0) : 0;
                            totalsByYearFinal[y] = (totalsByYearFinal[y] || 0) + amount;
                        });
                    });
                });
            });
            totals = years.map(y => totalsByYearFinal[y] || 0);

            setInvestmentBreakdown({ ...data, years, totals });
            setShowBreakdown(true);
        } catch (error) {
            console.error('Error fetching investment breakdown:', error);
            setShowBreakdown(false);
            setInvestmentBreakdown(null);
            throw error;
        }
    };
    // Add a useEffect to trigger API breakdown fetch if no data is found
    useEffect(() => {
        if (proposalData && !investmentBreakdown) {
            const timer = setTimeout(() => {
                fetchInvestmentBreakdown();
            }, 1000); // Wait 1 second before fetching from API
            return () => clearTimeout(timer);
        }
    }, [proposalData, investmentBreakdown]);
    if (loading) {
        return (
            <div className="container-xl">
                <div className="text-center p-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        );
    }
    // Ensure data is complete before rendering
    if (!proposalData || !proposalData.client || !proposalData.template || !proposalData.assigned_to || !proposalData.proposal_sections) {
        return (
            <div className="container-xl">
                <div className="text-center p-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading proposal data...</span>
                    </div>
                    <p className="mt-2">Loading proposal data...</p>
                </div>
            </div>
        );
    }
    const renderServiceTable = (services, title, type = null) => (
        <div className="card mt-3">
            <div className="card-body">
                <div className="col-12">
                    <h4>{title}</h4>
                    {type && (
                        <div className="col-md-4 mb-3">
                            <div className="form-control">{type}</div>
                        </div>
                    )}
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <colgroup>
                                <col style={{ width: '20%' }} />
                                <col style={{ width: '15%' }} />
                                <col style={{ width: '20%' }} />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th style={{ minWidth: '200px' }}>Standard</th>
                                    <th style={{ minWidth: '200px' }}>Product Category</th>
                                    <th style={{ minWidth: '200px' }}>Service Item</th>
                                </tr>
                            </thead>
                            <tbody>
                                {services.map((service, index) => (
                                    <React.Fragment key={index}>
                                        <tr>
                                            <td>
                                                {service.standard}
                                                {service.version && service.version.trim() !== '' && `:${service.version}`}
                                            </td>
                                            <td>{service.product_type}</td>
                                            <td>{service.service_item}</td>
                                        </tr>
                                        {service.sub_services && service.sub_services.map((subService, subIndex) => (
                                            <tr key={`${index}-${subIndex}`} className="table-light">
                                                <td className="text-end pe-2">
                                                    <small className="text-muted">↳</small>
                                                </td>
                                                <td>{subService.product_type}</td>
                                                <td>{subService.service_item}</td>
                                            </tr>
                                        ))}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
    // ========== PDF CREATION FUNCTIONS (MOVED FROM EDITPROPOSAL) ==========
    // Note: Most PDF functions already exist above, reusing them
    // Only adding the missing functions and the main handler
    // Function to download saved filled document (new function)
    const downloadSavedFilledDocument = async (proposalId) => {
        try {
            const response = await api.get(`/crm/proposals/${proposalId}/download-filled-document`, {
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `proposal_${proposalId}_filled.docx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Error downloading filled document:', error);
        }
    };
    // Function to process template only (new function)
    const processTemplateOnly = async (proposalId, templateId) => {
        if (!templateId) {
            return { success: true, message: 'No template to process' };
        }
        try {
            // Download dan fill template (DOCX) - using existing function
            const filledDocxBlob = await downloadAndFillTemplate(templateId, proposalId);
            // Upload DOCX ter-fill (backend akan otomatis konversi ke PDF) - using existing function
            await uploadFilledDocument(filledDocxBlob, proposalId);
            return { success: true, message: 'Template processed successfully' };
        } catch (templateError) {
            console.error('Error processing template:', templateError);
            return { success: false, message: 'Template processing failed' };
        }
    };
    // Main handler for Create PDF button
    const handleCreatePdf = async () => {
        try {
            // Pastikan template dipilih
            if (!proposalData.proposalTemplateId) {
                setAlert({ type: 'warning', message: 'Please select a proposal template first.' });
                return;
            }
            // Pastikan proposal sudah ada (sudah di-save)
            const proposalId = await getProposalId(id);
            if (!proposalId) {
                setAlert({ type: 'warning', message: 'Proposal not found. Please save the proposal first.' });
                return;
            }
            // 🔔 Show loading alert
            setAlert({ type: 'info', message: 'Creating PDF... Please wait.' });
            // Proses template (fill dan upload DOCX, PDF handled by backend if applicable)
            const result = await processTemplateOnly(proposalId, proposalData.proposalTemplateId);
            if (result.success) {
                // Otomatis download dokumen terisi
                await downloadSavedFilledDocument(proposalId);
                setAlert({ type: 'success', message: 'Template processed successfully and file downloaded.' });
            } else {
                setAlert({ type: 'danger', message: 'Failed to process template.' });
            }
        } catch (error) {
            console.error('Error on Create PDF:', error);
            setAlert({ type: 'danger', message: 'Failed to create PDF. Please ensure the proposal is saved and a template is selected.' });
        }
    };

    // Handler for Download Word (DOCX with placeholders filled with newest data, no PDF conversion)
    const handleDownloadWord = async () => {
        try {
            // Pastikan template dipilih
            if (!proposalData.proposalTemplateId) {
                setAlert({ type: 'warning', message: 'Please select a proposal template first.' });
                return;
            }
            // Pastikan proposal sudah ada (sudah di-save)
            const proposalId = await getProposalId(id);
            if (!proposalId) {
                setAlert({ type: 'warning', message: 'Proposal not found. Please save the proposal first.' });
                return;
            }

            // Always create fresh document with newest data (don't use cached version)
            setAlert({ type: 'info', message: 'Generating Word document with latest data... Please wait.' });

            // Download and fill template with fresh data
            const filledDocxBlob = await downloadAndFillTemplate(proposalData.proposalTemplateId, proposalId);

            // Create download link for the freshly generated DOCX
            const url = window.URL.createObjectURL(filledDocxBlob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `proposal_${proposalData.proposal_number}_${proposalId}.docx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            setAlert({ type: 'success', message: 'Word document generated and downloaded successfully with latest data!' });
        } catch (error) {
            console.error('Error downloading Word document:', error);
            setAlert({ type: 'danger', message: 'Failed to download Word document: ' + (error.message || 'Unknown error') });
        }
    };
    const workflowFallbackCurrencyCode = proposalCurrencyCode !== 'IDR'
        ? proposalCurrencyCode
        : investmentBreakdown?.breakdown
            ?.flatMap(serviceRow => serviceRow.standards || [])
            .flatMap(standardRow => standardRow.serviceItems || [])
            .map(item => item.currencyCode)
            .find(code => code && String(code).toUpperCase() !== 'IDR') || 'IDR';

    const getQuotedTotalForYear = (year) => (investmentBreakdown?.breakdown || []).reduce((serviceTotal, serviceRow) => (
        serviceTotal + (serviceRow.standards || []).reduce((standardTotal, stdRow) => (
            standardTotal + (stdRow.serviceItems || []).reduce((itemTotal, item) => {
                if (!Array.isArray(item.years) || !item.years.includes(year)) return itemTotal;
                return itemTotal + (Number(item.unitPrice || 0) * Number(item.qty ?? 1));
            }, 0)
        ), 0)
    ), 0);
    const showConversionColumns = String(proposalCurrencyCode || 'IDR').toUpperCase() !== 'IDR';
    const breakdownBaseColumnCount = showConversionColumns ? 4 : 3;

    return (
        <>
            <style>{`
                .proposal-history-line::before {
                    content: none !important;
                    display: none !important;
                }
            `}</style>
            {alert && (
                <Alert type={alert.type} message={alert.message} onClose={() => setAlert(null)} />
            )}
            {/* Workflow Validation Modal */}
            <Modal
                isOpen={showWorkflowValidationModal}
                onClose={() => setShowWorkflowValidationModal(false)}
                title="Proposal can't be send"
                size="md"
            >
                <div className="modal-body">
                    <div className="alert alert-danger d-flex align-items-center" role="alert">
                        <div className="alert-icon me-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon alert-icon icon-2">
                                <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
                                <path d="M12 8v4"></path>
                                <path d="M12 16h.01"></path>
                            </svg>
                        </div>
                        <div>
                            To proceed with sending to client, the rate on the service item must comply with rate management.
                        </div>
                    </div>

                </div>
                <div className="modal-footer">
                    <a type="button" className="btn btn-outline-info" onClick={() => setShowWorkflowValidationModal(false)}>
                        Cancel
                    </a>
                </div>
            </Modal>
            {/* Workflow Review Modal */}
            <Modal
                isOpen={showWorkflowModal}
                onClose={handleWorkflowModalClose}
                title="Workflow Review Required"
                size="xl"
            >
                <div className="modal-body">
                    {loadingWorkflow ? (
                        <div className="text-center">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-2">Loading workflow items...</p>
                        </div>
                    ) : (
                        <>
                            <div className="alert alert-warning">
                                <h6 className="alert-heading">⚠️ Workflow Review Required</h6>
                                <p className="mb-0">
                                    The following service items require workflow review before sending to client:
                                </p>
                            </div>
                            {workflowItems.length > 0 ? (
                                <div className="table-responsive">
                                    <table className="table table-vcenter">
                                        <thead>
                                            <tr>
                                                <th>Service</th>
                                                <th>Standard</th>
                                                <th>Product Category</th>
                                                <th>Service Item</th>
                                                <th>Qty</th>
                                                <th>Unit</th>
                                                <th>Unit Price</th>
                                                <th>Workflow Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {workflowItems.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.serviceName}</td>
                                                    <td>{item.standardName}</td>
                                                    <td>{item.productCategoryName}</td>
                                                    <td>{item.serviceItemName}</td>
                                                    <td>{item.qty}</td>
                                                    <td>{item.unit}</td>
                                                    <td>
                                                        {(() => {
                                                            const workflowCurrencyCode = String(
                                                                item.currencyCode || workflowFallbackCurrencyCode
                                                            ).toUpperCase();
                                                            return new Intl.NumberFormat('id-ID', {
                                                                style: 'currency',
                                                                currency: workflowCurrencyCode,
                                                                minimumFractionDigits: 0
                                                            }).format(Number(item.unitPrice || 0));
                                                        })()}
                                                    </td>
                                                    <td>
                                                        <span className={`badge badge-${item.workflowStatus === 'pending' ? 'warning' : 'info'}`}>
                                                            {item.workflowStatus === 'pending' ? 'Pending Review' : 'Needs Approval'}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="text-center py-4">
                                    <p className="text-muted">No workflow items require review.</p>
                                </div>
                            )}

                            {/* ✅ TAMBAHAN: Note input for workflow review */}
                            <div className="mt-4">
                                <label className="form-label fw-bold">Note (Optional)</label>
                                {workflowNote && (
                                    <div className="alert alert-info mb-2">
                                        <small>
                                            <strong>Previous note:</strong> {workflowNote}
                                            <br />
                                            <em>You can update this note or leave it as is.</em>
                                        </small>
                                    </div>
                                )}
                                <textarea
                                    className="form-control"
                                    rows={3}
                                    placeholder={workflowNote ? "Update the note or leave as is..." : "Add any notes or comments about this workflow review..."}
                                    value={workflowNote}
                                    onChange={(e) => setWorkflowNote(e.target.value)}
                                    disabled={loadingWorkflow}
                                />
                                <small className="text-muted">
                                    {workflowNote
                                        ? "This note will be updated and visible to approvers in the Dashboard."
                                        : "This note will be visible to approvers in the Dashboard."}
                                </small>
                            </div>
                        </>
                    )}
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={handleWorkflowModalClose}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSetNeedApproval}
                        disabled={loadingWorkflow}
                    >
                        Ok
                    </button>
                </div>
            </Modal>
            {/* Send to Client Confirmation Modal */}
            <ConfirmationModal
                isOpen={showSendToClientModal}
                onClose={() => setShowSendToClientModal(false)}
                onConfirm={confirmSendToClient}
                title="Send to Client"
                message="Are you sure you want to send this proposal to the client?"
                confirmText={isProcessingSend || isSendingEmail ? 'Sending...' : 'Send'}
                cancelText="Cancel"
                confirmVariant="primary"
                modalId="modal-send-to-client"
                ariaHidden={false}
                isLoading={isProcessingSend || isSendingEmail}
            />
            {/* Convert to Project Confirmation Modal */}
            <ConfirmationModal
                isOpen={showConvertToProjectModal}
                onClose={() => {
                    if (!isConvertingProject) {
                        setShowConvertToProjectModal(false);
                        setIsValidatingNpwp(false);
                    }
                }}
                onConfirm={() => {
                    confirmConvertToProject();
                }}
                title="Convert to Project"
                message="Convert this proposal to a project?"
                confirmText={isConvertingProject ? "Converting..." : "Convert"}
                cancelText="Cancel"
                confirmVariant="primary"
                modalId="modal-convert-to-project"
                isLoading={isConvertingProject}
            />
            {/* Accept Proposal Confirmation Modal */}
            <ConfirmationModal
                isOpen={showAcceptProposalModal}
                onClose={() => setShowAcceptProposalModal(false)}
                onConfirm={confirmAcceptProposal}
                title="Accept Proposal"
                message="Are you sure you want to accept this proposal? This will change the proposal status to 'Accepted'."
                confirmText="Accept"
                cancelText="Cancel"
                confirmVariant="success"
                modalId="modal-accept-proposal"
            />
            {/* Delete File Confirmation Modal */}
            <ConfirmationModal
                isOpen={showDeleteFileModal}
                onClose={() => setShowDeleteFileModal(false)}
                onConfirm={confirmDeleteFile}
                title="Delete File"
                message={`Are you sure you want to delete "${fileToDelete?.fileName || fileToDelete?.name || 'this file'}"? This action cannot be undone.`}
                confirmText="Delete"
                cancelText="Cancel"
                confirmVariant="danger"
                modalId="modal-delete-file"
            />
            {/* Lost stage: confirmation modal to select reason (from API /crm/reason-loss/all) */}
            <Modal
                isOpen={showLostReasonModal}
                onClose={closeLostReasonModal}
                title="Mark proposal as lost"
                size="md"
            >
                <div className="modal-body">
                    <p className="mb-3">Please select the reason for marking this proposal as lost.</p>
                    <div className="mb-3">
                        <label className="form-label required">Reason</label>
                        <FormFieldSelect
                            value={lostReason}
                            onChange={(e) => setLostReason(e.target.value)}
                            aria-label="Reason for loss"
                            disabled={loadingReasonLoss}
                        >
                            <option value="">
                                {loadingReasonLoss ? 'Loading...' : 'Select a reason...'}
                            </option>
                            {reasonLossOptions.map((r) => (
                                <option key={r.id} value={String(r.id)}>
                                    {r.name ?? r.label ?? String(r.id)}
                                </option>
                            ))}
                        </FormFieldSelect>
                    </div>
                    <div className="mb-0">
                        <label className="form-label">Note</label>
                        <textarea
                            className="form-control"
                            name="note"
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                            placeholder="Optional note..."
                            rows={3}
                            aria-label="Note"
                        />
                    </div>
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={closeLostReasonModal}
                        disabled={isSubmittingLost}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={confirmLostStage}
                        disabled={!lostReason || isSubmittingLost || loadingReasonLoss}
                    >
                        {isSubmittingLost ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                                Updating...
                            </>
                        ) : (
                            'Confirm'
                        )}
                    </button>
                </div>
            </Modal>
            {/* NPWP Validation Modal - now allows filling NPWP inline instead of redirecting to Edit Company */}
            {showNpwpValidationModal && (
                <Modal
                    isOpen={showNpwpValidationModal}
                    onClose={() => {
                        setShowNpwpValidationModal(false);
                        setCompanyData(null);
                        setNpwpValidationCompanyId(null);
                        setNpwpInputValue('');
                        setIsValidatingNpwp(false);
                    }}
                    title="Cannot Convert to Project"
                    size="md"
                >
                    <div className="modal-body">
                        <div className="alert alert-danger d-flex align-items-center" role="alert">
                            <div className="alert-icon me-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon alert-icon icon-2">
                                    <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
                                    <path d="M12 8v4"></path>
                                    <path d="M12 16h.01"></path>
                                </svg>
                            </div>
                            <div>
                                To proceed with converting to project, the Company Tax Number (NPWP) must be filled in.
                                <br />
                                <strong>Company: {companyData?.name || proposalData?.client?.name}</strong>
                            </div>
                        </div>
                        <div className="mb-2">
                            <label className="form-label">Company Tax Number (NPWP)</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter NPWP"
                                value={npwpInputValue}
                                onChange={(e) => setNpwpInputValue(e.target.value)}
                                disabled={isSavingNpwp}
                                autoFocus
                            />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-outline-info"
                            disabled={isSavingNpwp}
                            onClick={() => {
                                setShowNpwpValidationModal(false);
                                setCompanyData(null);
                                setNpwpValidationCompanyId(null);
                                setNpwpInputValue('');
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            disabled={isSavingNpwp}
                            onClick={handleSaveNpwpAndContinue}
                        >
                            {isSavingNpwp ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                                    Saving...
                                </>
                            ) : (
                                'Save & Continue'
                            )}
                        </button>
                    </div>
                </Modal>
            )}
            <div className="container-xl">
                <div className="page-header d-print-none">
                    <div className="row align-items-center">
                        <div className="col">
                            <div className="d-flex align-items-center">
                                <div className="d-flex align-items-center">
                                    <a className="btn btn-outline-white d-none d-sm-inline-block me-3" onClick={handleBack}>
                                        <ArrowLeft className="icon icon-tabler icon-tabler-arrow-left" />
                                        Back
                                    </a>
                                    <h3 className="page-title mb-0">Proposal Details</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row align-items-center">
                    <div className="col-md-8 mt-3">
                        <p className="mb-2">
                            <span className="text-muted fw-normal">Company Name: </span>
                            {(() => {
                                // Try to find company ID from multiple sources (same as NPWP validation)
                                const clickableCompanyId = companyId || proposalData?.companyId || leadData?.companyId || leadData?.company?.id;
                                return clickableCompanyId ? (
                                    <a
                                        href={`/clients/${clickableCompanyId}`}
                                        className="text-primary text-decoration-none fw-bold"
                                        onClick={(e) => {
                                            // Allow right-click, Ctrl+Click, Cmd+Click to open in new tab
                                            if (e.ctrlKey || e.metaKey || e.button === 1) {
                                                return; // Let browser handle it
                                            }
                                            e.preventDefault();
                                            e.stopPropagation();
                                            navigate(`/clients/${clickableCompanyId}`);
                                        }}
                                        onAuxClick={(e) => {
                                            // Handle middle mouse button click
                                            if (e.button === 1) {
                                                return; // Let browser handle it
                                            }
                                        }}
                                        title={`View client details for ${proposalData.client.name}`}
                                        aria-label={`View client details for ${proposalData.client.name}`}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                navigate(`/clients/${clickableCompanyId}`);
                                            }
                                        }}
                                    >
                                        {proposalData.client.name}
                                    </a>
                                ) : (
                                    <span className="text-dark fw-bold">{proposalData.client.name}</span>
                                );
                            })()}
                        </p>
                        {leadData && (
                            <p className="mb-2">
                                <span className="text-muted fw-normal">Project Name: </span>
                                <a
                                    href={`/leads/detail/${leadData.id}`}
                                    className="text-primary text-decoration-none fw-bold"
                                    onClick={(e) => {
                                        // Allow right-click, Ctrl+Click, Cmd+Click to open in new tab
                                        if (e.ctrlKey || e.metaKey || e.button === 1) {
                                            return; // Let browser handle it
                                        }
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleNavigateToLeadDetail(leadData.id);
                                    }}
                                    onAuxClick={(e) => {
                                        // Handle middle mouse button click
                                        if (e.button === 1) {
                                            return; // Let browser handle it
                                        }
                                    }}
                                    title={`View lead details for ${leadData.projectName}`}
                                    aria-label={`View lead details for ${leadData.projectName}`}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            handleNavigateToLeadDetail(leadData.id);
                                        }
                                    }}
                                >
                                    {leadData.projectName || 'Project Name'}
                                </a>
                            </p>
                        )}
                        <p className="mb-2">
                            <span className="text-muted fw-normal">Proposal Number: </span>
                            <span className="text-dark fw-bold">{proposalData.proposal_number}</span>
                        </p>
                        {projectData && (
                            <p className="mb-2">
                                <span className="text-muted fw-normal">Project Number: </span>
                                <a
                                    href={`/projects/detail/${leadData?.id || id}`}
                                    className="text-primary text-decoration-none fw-bold"
                                    onClick={(e) => {
                                        // Allow right-click, Ctrl+Click, Cmd+Click to open in new tab
                                        if (e.ctrlKey || e.metaKey || e.button === 1) {
                                            return; // Let browser handle it
                                        }
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleNavigateToProjectDetail(leadData?.id || id);
                                    }}
                                    onAuxClick={(e) => {
                                        // Handle middle mouse button click
                                        if (e.button === 1) {
                                            return; // Let browser handle it
                                        }
                                    }}
                                    title={`View project details for ${projectData.projectCode || 'Project'}`}
                                    aria-label={`View project details for ${projectData.projectCode || 'Project'}`}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            handleNavigateToProjectDetail(leadData?.id || id);
                                        }
                                    }}
                                >
                                    {projectData.projectCode || 'Project Code'}
                                </a>
                            </p>
                        )}
                        {/* Proposal Stage Dropdown */}
                        <div className="col-md-4 mt-2">
                            <div className="d-flex align-items-center">
                                <label className="form-label fw-bold me-2 mb-0">Proposal Stage:</label>
                                <div style={{ minWidth: '200px' }} className="d-flex align-items-center">
                                    <div className="proposal-stage-select-wrapper" style={{ marginBottom: 0 }}>
                                        <AppSelect
                                            name="proposalStage"
                                            value={selectedProposalStage}
                                            onChange={(name, value) => handleProposalStageChange(value)}
                                            options={proposalStages}
                                            placeholder="Select a stage..."
                                            valueField="id"
                                            labelField="name"
                                            disabled={loadingProposalStages}
                                            label=""
                                        />
                                    </div>
                                </div>
                            </div>
                            {loadingProposalStages && (
                                <div className="mt-1">
                                    <small className="text-muted">
                                        <div className="spinner-border spinner-border-sm me-1" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        Loading stages...
                                    </small>
                                </div>
                            )}
                        </div>
                        {/* Tagging multi-select (below Proposal Stage) */}
                        <div className="col-md-4 mt-2">
                            <div className="d-flex align-items-center">
                                <label className="form-label fw-bold me-2 mb-0">Tagging:</label>
                                <div style={{ minWidth: '200px' }}>
                                    <AppSelect
                                        name="tagging"
                                        value={selectedTaggingIds}
                                        onChange={handleTaggingChange}
                                        options={taggingOptions}
                                        placeholder="Select taggings..."
                                        valueField="id"
                                        labelField="name"
                                        multiple
                                        disabled={loadingTaggingOptions || !proposalData?.id || savingTagging}
                                        label=""
                                    />
                                </div>
                            </div>
                            {savingTagging && (
                                <small className="text-muted">Saving...</small>
                            )}
                            {loadingTaggingOptions && (
                                <div className="mt-1">
                                    <small className="text-muted">Loading taggings...</small>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="d-flex align-items-end justify-content-end">
                            {/* ✅ TAMBAHAN: Hide tombol Send to Client jika STATUS PROPOSAL = "Accepted" (kode 3) */}
                            {proposalData?.statusProposal !== 3 && proposalData?.statusApproval !== 'Approved' && (
                                <button
                                    className="btn btn-primary me-2"
                                    onClick={onSendToClient}
                                    disabled={sendToClientDisabled || isProcessingSend}
                                >
                                    {isProcessingSend ? (
                                        <>
                                            <div className="spinner-border spinner-border-sm me-2" role="status">
                                                <span className="visually-hidden">Processing...</span>
                                            </div>
                                            Processing...
                                        </>
                                    ) : (
                                        <>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="icon icon-tabler icons-tabler-outline icon-tabler-send"
                                                style={{ marginRight: 8, verticalAlign: 'middle' }}
                                            >
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                <path d="M10 14l11 -11" />
                                                <path d="M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5" />
                                            </svg>
                                            {sendToClientLabel}
                                        </>
                                    )}
                                </button>
                            )}
                            {/* ✅ Show info when STATUS PROPOSAL = "Accepted" or STATUS APPROVAL = "Approved" */}
                            {(proposalData?.statusProposal === 3 || proposalData?.statusApproval === 'Approved') && (
                                <div className="alert alert-info me-2 mb-0 py-2 px-3">
                                    <small className="text-muted">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-check me-1" width="16" height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                            <path d="M5 12l5 5l10 -10"></path>
                                        </svg>
                                        Send to Client not available
                                    </small>
                                </div>
                            )}
                            <div className="dropdown" ref={actionsRef}>
                                <button
                                    type="button"
                                    id="actions-dropdown-button"
                                    className="btn btn-outline-primary dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded={actionsOpen}
                                    onClick={(e) => { e.stopPropagation(); setActionsOpen(v => !v); }}
                                >
                                    Actions
                                </button>
                                <div className={`dropdown-menu dropdown-menu-end${actionsOpen ? ' show' : ''}`} role="menu" aria-labelledby="actions-dropdown-button" style={{ right: 0, left: 'auto' }}>
                                <li><a className="dropdown-item" href="#" onClick={handlePreview}>Proposal Preview</a></li>
                                <li>
                                    <a
                                        className="dropdown-item"
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            navigate(`/proposals/view/${id}`);
                                        }}
                                        title="View this proposal in read-only layout"
                                    >
                                        Proposal View
                                    </a>
                                </li>
                                <li>
                                    <a
                                        className={`dropdown-item ${
                                            (() => {
                                                const isDraft =
                                                    proposalData?.statusProposal === 1 ||
                                                    proposalData?.statusProposalDesc === 'Draft';
                                                const isRevision =
                                                    proposalData?.statusDesc === 'Revision' ||
                                                    proposalData?.statusApproval === 'Revision';
                                                const isFeedback =
                                                    proposalData?.statusProposal === 5 ||
                                                    proposalData?.statusProposalDesc === 'Feedback';

                                                // Allow editing only for draft, revision, and feedback statuses
                                                return (isDraft || isRevision || isFeedback)
                                                    ? ''
                                                    : 'disabled text-muted';
                                            })()
                                            }`}
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();

                                            const isDraft =
                                                proposalData?.statusProposal === 1 ||
                                                proposalData?.statusProposalDesc === 'Draft';
                                            const isRevision =
                                                proposalData?.statusDesc === 'Revision' ||
                                                proposalData?.statusApproval === 'Revision';
                                            const isFeedback =
                                                proposalData?.statusProposal === 5 ||
                                                proposalData?.statusProposalDesc === 'Feedback';

                                            // Only allow editing for draft, revision, and feedback statuses
                                            if (isDraft || isRevision || isFeedback) {
                                                handleEdit();
                                                return;
                                            }

                                            // Show appropriate error message for other statuses
                                            let reason = 'Cannot edit: ';
                                            const statusDesc = proposalData?.statusProposalDesc || proposalData?.statusDesc || 'Unknown';

                                            if (proposalData?.statusApproval === 'Approved' || proposalData?.statusDesc === 'Approved') {
                                                reason += 'Proposal is already approved';
                                            } else if (proposalData?.statusProposal === 3 || proposalData?.statusProposalDesc === 'Accepted') {
                                                reason += 'Proposal is already accepted';
                                            } else if (proposalData?.statusProposal === 2 || proposalData?.statusProposalDesc === 'Send to Client' || proposalData?.statusProposalDesc === 'Send To Client') {
                                                reason += 'Proposal has been sent to client';
                                            } else if (proposalData?.statusDesc === 'Need Approval' || proposalData?.statusApproval === 'Need Approval') {
                                                reason += 'Proposal is waiting for approval';
                                            } else if (projectStatus === 'Converted') {
                                                reason += 'Proposal is already converted to project';
                                            } else {
                                                reason += `Current status is "${statusDesc}"`;
                                            }

                                            setAlert({
                                                type: 'warning',
                                                message: `Cannot edit: ${reason}.`
                                            });
                                            return;
                                        }}
                                        style={{
                                            cursor: /* (() => {
                                            const isApproved =
                                                proposalData?.status === 2 ||
                                                proposalData?.statusDesc === 'Approved' ||
                                                proposalData?.statusApproval === 'Approved';
                                            const isFeedback =
                                                proposalData?.statusProposal === 5 ||
                                                proposalData?.statusProposalDesc === 'Feedback';
                                            const isAccepted =
                                                proposalData?.statusProposal === 3 ||
                                                proposalData?.statusProposalDesc === 'Accepted';
                                            const isConverted = projectStatus === 'Converted';

                                            if (isApproved && isFeedback) return 'pointer';
                                            return (isApproved || isAccepted || isConverted)
                                                ? 'not-allowed'
                                                : 'pointer';
                                        })() */
                                            (() => {
                                                const isDraft =
                                                    proposalData?.statusProposal === 1 ||
                                                    proposalData?.statusProposalDesc === 'Draft';
                                                const isRevision =
                                                    proposalData?.statusDesc === 'Revision' ||
                                                    proposalData?.statusApproval === 'Revision';
                                                const isFeedback =
                                                    proposalData?.statusProposal === 5 ||
                                                    proposalData?.statusProposalDesc === 'Feedback';

                                                return (isDraft || isRevision || isFeedback)
                                                    ? 'pointer'
                                                    : 'not-allowed';
                                            })()
                                        }}
                                        title={
                                            (() => {
                                                const isDraft =
                                                    proposalData?.statusProposal === 1 ||
                                                    proposalData?.statusProposalDesc === 'Draft';
                                                const isRevision =
                                                    proposalData?.statusDesc === 'Revision' ||
                                                    proposalData?.statusApproval === 'Revision';
                                                const isFeedback =
                                                    proposalData?.statusProposal === 5 ||
                                                    proposalData?.statusProposalDesc === 'Feedback';

                                                if (isDraft || isRevision || isFeedback) {
                                                    return 'Edit this proposal';
                                                }

                                                // Determine reason for disabled state
                                                let reason = 'Cannot edit: ';
                                                const statusDesc = proposalData?.statusProposalDesc || proposalData?.statusDesc || 'Unknown';

                                                if (proposalData?.statusApproval === 'Approved' || proposalData?.statusDesc === 'Approved') {
                                                    reason += 'Proposal is already approved';
                                                } else if (proposalData?.statusProposal === 3 || proposalData?.statusProposalDesc === 'Accepted') {
                                                    reason += 'Proposal is already accepted';
                                                } else if (proposalData?.statusProposal === 2 || proposalData?.statusProposalDesc === 'Send to Client' || proposalData?.statusProposalDesc === 'Send To Client') {
                                                    reason += 'Proposal has been sent to client';
                                                } else if (proposalData?.statusDesc === 'Need Approval' || proposalData?.statusApproval === 'Need Approval') {
                                                    reason += 'Proposal is waiting for approval';
                                                } else if (projectStatus === 'Converted') {
                                                    reason += 'Proposal is already converted to project';
                                                } else {
                                                    reason += `Current status is "${statusDesc}"`;
                                                }

                                                return reason;
                                            })()
                                        }
                                    >
                                        Proposal Edit
                                    </a>
                                </li>

                                <li><a className="dropdown-item" href="#" onClick={handleCreatePdf}>Create PDF</a></li>
                                <li><a className="dropdown-item" href="#" onClick={handleDownloadPDF}>Download PDF</a></li>
                                <li><a className="dropdown-item" href="#" onClick={(e) => {
                                    e.preventDefault();
                                    handleDownloadWord();
                                }}>
                                    Download Word
                                </a></li>
                                <li><hr className="dropdown-divider" /></li>
                                <li>
                                    <a
                                        className={`dropdown-item ${(() => {
                                            const isSendToClient = proposalData?.statusProposal === 2 || proposalData?.statusProposalDesc === 'Send To Client' || proposalData?.statusProposalDesc === 'Send to Client';
                                            const isFeedback = proposalData?.statusProposal === 5 || proposalData?.statusProposalDesc === 'Feedback';
                                            const canAccept = isSendToClient || isFeedback;
                                            return !canAccept ? 'disabled text-muted' : '';
                                        })()}`}
                                        href="#"
                                        onClick={(e) => {
                                            const isSendToClient = proposalData?.statusProposal === 2 || proposalData?.statusProposalDesc === 'Send To Client' || proposalData?.statusProposalDesc === 'Send to Client';
                                            const isFeedback = proposalData?.statusProposal === 5 || proposalData?.statusProposalDesc === 'Feedback';
                                            const isAccepted = proposalData?.statusProposal === 3 || proposalData?.statusProposalDesc === 'Accepted';
                                            const isDraft = proposalData?.statusProposal === 1 || proposalData?.statusProposalDesc === 'Draft';
                                            const isRejected = proposalData?.statusProposal === 4 || proposalData?.statusProposalDesc === 'Rejected';
                                            const canAccept = isSendToClient || isFeedback;

                                            if (!canAccept) {
                                                e.preventDefault();
                                                let message = 'Only proposals with "Send to Client" or "Feedback" status can be accepted.';
                                                if (isAccepted) {
                                                    message = 'This proposal has already been accepted.';
                                                } else if (isDraft) {
                                                    message = 'Cannot accept: Proposal is still in Draft. Please send to client first.';
                                                } else if (isRejected) {
                                                    message = 'Cannot accept: Proposal was rejected.';
                                                }
                                                setAlert({
                                                    type: 'warning',
                                                    message: message
                                                });
                                            } else {
                                                handleAcceptProposal();
                                            }
                                        }}
                                        style={{
                                            cursor: (() => {
                                                const isSendToClient = proposalData?.statusProposal === 2 || proposalData?.statusProposalDesc === 'Send To Client' || proposalData?.statusProposalDesc === 'Send to Client';
                                                const isFeedback = proposalData?.statusProposal === 5 || proposalData?.statusProposalDesc === 'Feedback';
                                                const canAccept = isSendToClient || isFeedback;
                                                return canAccept ? 'pointer' : 'not-allowed';
                                            })()
                                        }}
                                        title={(() => {
                                            const isSendToClient = proposalData?.statusProposal === 2 || proposalData?.statusProposalDesc === 'Send To Client' || proposalData?.statusProposalDesc === 'Send to Client';
                                            const isFeedback = proposalData?.statusProposal === 5 || proposalData?.statusProposalDesc === 'Feedback';
                                            const canAccept = isSendToClient || isFeedback;
                                            const currentStatus = proposalData?.statusProposalDesc || 'Draft';

                                            if (canAccept) return 'Accept this proposal';
                                            return `Cannot accept: Only "Send to Client" or "Feedback" status can be accepted (current: ${currentStatus})`;
                                        })()}
                                    >
                                        {isAcceptingProposal && (
                                            <div className="spinner-border spinner-border-sm me-2" role="status">
                                                <span className="visually-hidden">Accepting...</span>
                                            </div>
                                        )}
                                        Accept Proposal
                                    </a>
                                </li>
                                <li>
                                    <a
                                        className={`dropdown-item d-flex align-items-center ${(proposalData?.statusProposal !== 3 || projectStatus === 'Converted' || isValidatingNpwp || loading || !leadData) ? 'disabled text-muted' : ''}`}
                                        href="#"
                                        onClick={(proposalData?.statusProposal === 3 && projectStatus !== 'Converted' && !isValidatingNpwp && !loading && leadData) ? (e) => {
                                            handleConvertToProject(e);
                                        } : (e) => {
                                            e.preventDefault();
                                            if (loading || !leadData) {
                                                setAlert({
                                                    type: 'warning',
                                                    message: 'Please wait for proposal data to load.'
                                                });
                                            } else if (projectStatus === 'Converted') {
                                                setAlert({
                                                    type: 'info',
                                                    message: 'This proposal has already been converted to a project.'
                                                });
                                            } else if (isValidatingNpwp) {
                                                // Do nothing, validation in progress
                                            } else {
                                                setAlert({
                                                    type: 'warning',
                                                    message: `Cannot convert to project: Proposal status must be 'Accepted' (current status: ${proposalData?.statusProposalDesc || proposalData?.statusProposal}). Only proposals with 'Accepted' status can be converted to projects.`
                                                });
                                            }
                                        }}
                                        style={{ cursor: (proposalData?.statusProposal === 3 && projectStatus !== 'Converted' && !isValidatingNpwp && !loading && leadData) ? 'pointer' : 'not-allowed' }}
                                        title={(loading || !leadData) ?
                                            'Loading proposal data...' :
                                            (projectStatus === 'Converted' ?
                                                'Already converted to project' :
                                                (isValidatingNpwp ?
                                                    'Validating company information...' :
                                                    (proposalData?.statusProposal !== 3 ?
                                                        `Only proposals with 'Accepted' status can be converted to projects (current status: ${proposalData?.statusProposalDesc || proposalData?.statusProposal})` :
                                                        'Convert this proposal to a project'
                                                    )
                                                )
                                            )
                                        }
                                    >
                                        {(isConvertingProject || isValidatingNpwp) && (
                                            <div className="spinner-border spinner-border-sm me-2" role="status">
                                                <span className="visually-hidden">{isConvertingProject ? 'Converting...' : 'Validating...'}</span>
                                            </div>
                                        )}
                                        {projectStatus === 'Converted' ? (
                                            <>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler me-2">
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path d="M9 11l3 3l8 -8" />
                                                    <path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9" />
                                                </svg>
                                                Converted
                                            </>
                                        ) : (
                                            isValidatingNpwp ? 'Validating Company...' : 'Convert to Project'
                                        )}

                                    </a>
                                </li>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="page-body mt-3">
                    <div className="row">
                        <div className="col-md-8">
                            <div className="card">
                                <div className="card-header">
                                    <ul className="nav nav-tabs card-header-tabs" role="tablist">
                                        <li className="nav-item-tab" role="presentation">
                                            <a
                                                href="#tabs-proposal-item"
                                                className={`nav-link ${activeTab === 'tabs-proposal-item' ? 'active' : ''}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleTabChange('tabs-proposal-item');
                                                }}
                                                aria-selected={activeTab === 'tabs-proposal-item'}
                                                role="tab"
                                            >
                                                Proposal Item
                                            </a>
                                        </li>
                                        <li className="nav-item-tab" role="presentation">
                                            <a
                                                href="#tabs-proposal-view"
                                                className={`nav-link ${activeTab === 'tabs-proposal-view' ? 'active' : ''}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleTabChange('tabs-proposal-view');
                                                }}
                                                aria-selected={activeTab === 'tabs-proposal-view'}
                                                role="tab"
                                            >
                                                Proposal View
                                            </a>
                                        </li>
                                        <li className="nav-item-tab" role="presentation">
                                            <a
                                                href="#tabs-files"
                                                className={`nav-link ${activeTab === 'tabs-files' ? 'active' : ''}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleTabChange('tabs-files');
                                                }}
                                                aria-selected={activeTab === 'tabs-files'}
                                                role="tab"
                                            >
                                                Files
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="card-body">
                                    <div className="tab-content">
                                        <div className={`tab-pane ${activeTab === 'tabs-proposal-item' ? 'active show' : ''}`} id="tabs-proposal-item" role="tabpanel">
                                            {/* Investment Breakdown Table */}
                                            <div className="card w-100">
                                                <div className="card-header">
                                                    <h5 className="card-title mb-0">
                                                        Investment Breakdown
                                                        {investmentBreakdown && ` (${investmentBreakdown.years.length} Years)`}
                                                    </h5>
                                                </div>
                                                <div className="card-body">
                                                    {investmentBreakdown ? (
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Details</th>
                                                                        <th style={{ width: '80px', minWidth: '80px' }}>Unit</th>
                                                                        <th style={{ width: '60px', minWidth: '60px' }}>Qty</th>
                                                                        {showConversionColumns && <th style={{ width: '110px', minWidth: '110px' }}>Exchange Rate</th>}
                                                                        {investmentBreakdown.years.map(year => (
                                                                            <th key={year}>
                                                                                {year}
                                                                                <div className="text-muted fw-normal small">Quoted / IDR</div>
                                                                            </th>
                                                                        ))}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {investmentBreakdown.breakdown.map((serviceRow, sIdx) => (
                                                                        <React.Fragment key={sIdx}>
                                                                            <tr>
                                                                                <td className="fw-bold" colSpan={breakdownBaseColumnCount + investmentBreakdown.years.length}>{serviceRow.service}</td>
                                                                            </tr>
                                                                            {serviceRow.standards.map((stdRow, stdIdx) => (
                                                                                <React.Fragment key={stdIdx}>
                                                                                    <tr>
                                                                                        <td style={{ paddingLeft: 24, fontWeight: 'bold' }} colSpan={breakdownBaseColumnCount + investmentBreakdown.years.length}>
                                                                                            {stdRow.standard}
                                                                                            {stdRow.version && stdRow.version.trim() !== '' && `:${stdRow.version}`}
                                                                                            {stdRow.standard_scheme && stdRow.standard_scheme.trim() !== '' && ` (${stdRow.standard_scheme})`}
                                                                                        </td>
                                                                                    </tr>
                                                                                    {stdRow.serviceItems.map((item, cidx) => (
                                                                                        <tr key={cidx}>
                                                                                            <td style={{ paddingLeft: 48 }}>
                                                                                                {item.serviceItem}
                                                                                            </td>
                                                                                            <td style={{ width: '80px', minWidth: '80px' }}>{item.unit || '-'}</td>
                                                                                            <td style={{ width: '60px', minWidth: '60px' }}>
                                                                                                {item.qty != null ? (() => {
                                                                                                    const qtyNum = parseFloat(item.qty);
                                                                                                    // If it's a whole number, show without decimals
                                                                                                    if (qtyNum % 1 === 0) {
                                                                                                        return qtyNum.toString();
                                                                                                    }
                                                                                                    // For decimal numbers, remove trailing zeros (e.g., 1.50 -> 1.5, 1.00 -> 1)
                                                                                                    return qtyNum.toString().replace(/\.?0+$/, '');
                                                                                                })() : '-'}
                                                                                            </td>
                                                                                            {showConversionColumns && (
                                                                                                <td style={{ width: '110px', minWidth: '110px' }}>
                                                                                                    {Number(item.exchangeRate || 1).toLocaleString('id-ID')}
                                                                                                </td>
                                                                                            )}
                                                                                            {investmentBreakdown.years.map((year) => {
                                                                                                const yearIdx = item.years.indexOf(year);
                                                                                                if (yearIdx === -1) return <td key={year}>-</td>;
                                                                                                const amount = Number(item.prices[yearIdx] || 0);
                                                                                                const itemCurrency = String(item.currencyCode || 'IDR').toUpperCase();
                                                                                                const sourceAmount = Number(item.unitPrice || 0) * Number(item.qty ?? 1);
                                                                                                return (
                                                                                                    <td key={year} className="align-middle">
                                                                                                        {showConversionColumns ? <div className="rounded border bg-light px-2 py-1">
                                                                                                            <div className="d-flex justify-content-between align-items-center gap-2">
                                                                                                                <span className="text-muted small">{itemCurrency}</span>
                                                                                                                <span className="fw-semibold">
                                                                                                                    {getCurrencyPrefix(itemCurrency)}{sourceAmount.toLocaleString('id-ID')}
                                                                                                                </span>
                                                                                                            </div>
                                                                                                            <div className="border-top mt-1 pt-1 d-flex justify-content-between align-items-center gap-2">
                                                                                                                <span className="text-muted small">IDR</span>
                                                                                                                <span className="text-success fw-semibold">Rp {amount.toLocaleString('id-ID')}</span>
                                                                                                            </div>
                                                                                                        </div> : <span className="fw-semibold">Rp {amount.toLocaleString('id-ID')}</span>}
                                                                                                    </td>
                                                                                                );
                                                                                            })}
                                                                                        </tr>
                                                                                    ))}
                                                                                </React.Fragment>
                                                                            ))}
                                                                        </React.Fragment>
                                                                    ))}
                                                                </tbody>
                                                                <tfoot>
                                                                    <tr>
                                                                        <th>Total</th>
                                                                        <th></th>
                                                                        <th></th>
                                                                        {showConversionColumns && <th></th>}
                                                                        {investmentBreakdown.totals.length > 0
                                                                            ? investmentBreakdown.totals.map((total, i) => {
                                                                                const quotedTotal = getQuotedTotalForYear(investmentBreakdown.years[i]);
                                                                                return (
                                                                                    <th key={i} className="text-end">
                                                                                        {showConversionColumns ? <div className="rounded border bg-light px-2 py-1">
                                                                                            <div><span className="text-muted small">{proposalCurrencyCode}</span> {getCurrencyPrefix(proposalCurrencyCode)}{quotedTotal.toLocaleString('id-ID')}</div>
                                                                                            <div className="border-top mt-1 pt-1 text-success"><span className="text-muted small">IDR</span> Rp {total.toLocaleString('id-ID')}</div>
                                                                                        </div> : <span className="fw-semibold">Rp {total.toLocaleString('id-ID')}</span>}
                                                                                    </th>
                                                                                );
                                                                            })
                                                                            : (() => {
                                                                                const quotedTotal = Number(proposalData?.grandTotal || 0);
                                                                                const rate = Number(proposalData?.exchangeRateAtCreation || 1);
                                                                                const idrTotal = String(proposalCurrencyCode).toUpperCase() === 'IDR' ? quotedTotal : quotedTotal * rate;
                                                                                return (
                                                                                    <th className="text-end">
                                                                                        {showConversionColumns ? <div className="rounded border bg-light px-2 py-1">
                                                                                            <div><span className="text-muted small">{proposalCurrencyCode}</span> {getCurrencyPrefix(proposalCurrencyCode)}{quotedTotal.toLocaleString('id-ID')}</div>
                                                                                            <div className="border-top mt-1 pt-1 text-success"><span className="text-muted small">IDR</span> Rp {idrTotal.toLocaleString('id-ID')}</div>
                                                                                        </div> : <span className="fw-semibold">Rp {idrTotal.toLocaleString('id-ID')}</span>}
                                                                                    </th>
                                                                                );
                                                                            })()
                                                                        }
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Grand Total</th>
                                                                        <th colSpan={Math.max(investmentBreakdown.totals.length, 1) + (showConversionColumns ? 3 : 2)} className="text-end">
                                                                            {(() => {
                                                                                const computed = investmentBreakdown.totals.reduce((sum, t) => sum + t, 0);
                                                                                const quotedComputed = investmentBreakdown.years.reduce((sum, year) => sum + getQuotedTotalForYear(year), 0);
                                                                                if (investmentBreakdown.totals.length > 0) {
                                                                                    return showConversionColumns ? (
                                                                                        <div className="rounded border bg-light px-2 py-1 d-inline-block">
                                                                                            <div><span className="text-muted small">{proposalCurrencyCode}</span> {getCurrencyPrefix(proposalCurrencyCode)}{quotedComputed.toLocaleString('id-ID')}</div>
                                                                                            <div className="border-top mt-1 pt-1 text-success"><span className="text-muted small">IDR</span> Rp {computed.toLocaleString('id-ID')}</div>
                                                                                        </div>
                                                                                    ) : <span className="fw-semibold">Rp {computed.toLocaleString('id-ID')}</span>;
                                                                                }
                                                                                const display = proposalData?.grandTotal || 0;
                                                                                const rate = Number(proposalData?.exchangeRateAtCreation || 1);
                                                                                const idrDisplay = String(proposalCurrencyCode).toUpperCase() === 'IDR' ? display : display * rate;
                                                                                return showConversionColumns ? (
                                                                                    <div className="rounded border bg-light px-2 py-1 d-inline-block">
                                                                                        <div><span className="text-muted small">{proposalCurrencyCode}</span> {getCurrencyPrefix(proposalCurrencyCode)}{display.toLocaleString('id-ID')}</div>
                                                                                        <div className="border-top mt-1 pt-1 text-success"><span className="text-muted small">IDR</span> Rp {idrDisplay.toLocaleString('id-ID')}</div>
                                                                                    </div>
                                                                                ) : <span className="fw-semibold">Rp {idrDisplay.toLocaleString('id-ID')}</span>;
                                                                            })()}
                                                                        </th>
                                                                    </tr>
                                                                </tfoot>
                                                            </table>
                                                        </div>
                                                    ) : (
                                                        <div className="text-center py-4">
                                                            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-calculator mb-3" width="48" height="48" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                                <path d="M4 19m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z"></path>
                                                                <path d="M7 7m0 1a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"></path>
                                                                <path d="M7 15m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
                                                                <path d="M15 7l4 0"></path>
                                                                <path d="M15 11l4 0"></path>
                                                                <path d="M7 11l3 0"></path>
                                                                <path d="M7 15l4 0"></path>
                                                            </svg>
                                                            <h5 className="text-muted">Investment Breakdown</h5>
                                                            <p className="text-muted mb-0">The investment breakdown will appear here once the proposal data is loaded and calculated.</p>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`tab-pane ${activeTab === 'tabs-proposal-view' ? 'active show' : ''}`} id="tabs-proposal-view" role="tabpanel">
                                            {/* Document Viewer Section */}
                                            {(proposalData.proposalPdfFillPdf || proposalData.proposalPdfFill) ? (
                                                <div className="d-flex flex-column align-items-center justify-content-center mb-4" style={{ minHeight: 400 }}>
                                                    {documentError && (
                                                        <div className="alert alert-danger">{documentError}</div>
                                                    )}
                                                    {/* Preview PDF jika sudah di-convert, atau download jika masih docx */}
                                                    {showDocument && filledDocumentUrl && (
                                                        <iframe
                                                            src={filledDocumentUrl}
                                                            title="Filled Proposal Document"
                                                            width="100%"
                                                            height="900px"
                                                            style={{ border: '1px solid #ccc', maxWidth: 1080 }}
                                                        />
                                                    )}
                                                    {!showDocument && (
                                                        <div className="text-muted text-center">
                                                            {proposalData.proposalPdfFillPdf ?
                                                                'Document is available for viewing.' :
                                                                'Document is available for download.'
                                                            }
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                // Show message when no document is available
                                                <div className="d-flex flex-column align-items-center justify-content-center mb-4" style={{ minHeight: 400 }}>
                                                    <div className="text-center">
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-file-text mb-3" width="48" height="48" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                            <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
                                                            <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"></path>
                                                            <path d="M9 9l1 0"></path>
                                                            <path d="M9 13l6 0"></path>
                                                            <path d="M9 17l6 0"></path>
                                                        </svg>
                                                        <h4 className="text-muted">Your project's PDF will appear here once it's generated.</h4>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div className={`tab-pane ${activeTab === 'tabs-files' ? 'active show' : ''}`} id="tabs-files" role="tabpanel">
                                            {/* File Upload Section */}
                                            <div className="mb-4">
                                                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                                                    <h3 className="mb-0">Files</h3>
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        onClick={() => {
                                                            setUploadCategory('Proposal');
                                                            setSelectedLeadServiceId(leadServiceOptions.length === 1 ? String(leadServiceOptions[0].id) : '');
                                                            setShowUploadModal(true);
                                                        }}
                                                        disabled={uploadingFile}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-upload me-2" width="16" height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                            <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path>
                                                            <path d="M7 9l5 -5l5 5"></path>
                                                            <path d="M12 4l0 12"></path>
                                                        </svg>
                                                        Upload File
                                                    </button>
                                                </div>
                                            </div>
                                            {/* Upload File Modal */}
                                            <Modal
                                                isOpen={showUploadModal}
                                                onClose={() => !uploadingFile && setShowUploadModal(false)}
                                                title="Upload File"
                                                size="md"
                                            >
                                                <div className="modal-body">
                                                    <div className="mb-3">
                                                        <label className="form-label">Save to</label>
                                                        <FormFieldSelect
                                                            value={uploadCategory}
                                                            onChange={(e) => {
                                                                setUploadCategory(e.target.value);
                                                                setSelectedLeadServiceId(leadServiceOptions.length === 1 ? String(leadServiceOptions[0].id) : '');
                                                            }}
                                                            disabled={uploadingFile}
                                                        >
                                                            <option value="Proposal">Proposal Document</option>
                                                            <option value="CID1">Lead - CID1</option>
                                                            <option value="CID2">Lead - CID2</option>
                                                            <option value="Other">Lead - Other Files</option>
                                                        </FormFieldSelect>
                                                    </div>
                                                    {uploadCategory !== 'Proposal' && (
                                                        <div className="mb-3">
                                                            <label className="form-label">Service</label>
                                                            <FormFieldSelect
                                                                value={selectedLeadServiceId}
                                                                onChange={(e) => setSelectedLeadServiceId(e.target.value)}
                                                                disabled={uploadingFile}
                                                            >
                                                                <option value="">Select service...</option>
                                                                {leadServiceOptions.map((svc) => (
                                                                    <option key={svc.id} value={svc.id}>
                                                                        {svc.serviceName || `Service #${svc.serviceId}`}
                                                                    </option>
                                                                ))}
                                                            </FormFieldSelect>
                                                            {leadServiceOptions.length === 0 && (
                                                                <div className="form-text text-warning">No services found on this lead yet.</div>
                                                            )}
                                                        </div>
                                                    )}
                                                    <div
                                                        {...getUploadRootProps()}
                                                        className={`dropzone ${isUploadDragActive ? 'active' : ''}`}
                                                        style={{
                                                            border: `2px dashed ${uploadingFile || (uploadCategory !== 'Proposal' && !selectedLeadServiceId) ? '#e5e5e5' : '#ccc'}`,
                                                            borderRadius: '4px',
                                                            padding: '30px 20px',
                                                            textAlign: 'center',
                                                            cursor: uploadingFile || (uploadCategory !== 'Proposal' && !selectedLeadServiceId) ? 'not-allowed' : 'pointer',
                                                            backgroundColor: isUploadDragActive ? '#f8f9fa' : 'white'
                                                        }}
                                                    >
                                                        <input {...getUploadInputProps()} />
                                                        {uploadingFile ? (
                                                            <>
                                                                <div className="spinner-border spinner-border-sm me-2" role="status">
                                                                    <span className="visually-hidden">Uploading...</span>
                                                                </div>
                                                                Uploading...
                                                            </>
                                                        ) : uploadCategory !== 'Proposal' && !selectedLeadServiceId ? (
                                                            <span className="text-muted">Select a service first</span>
                                                        ) : (
                                                            <>
                                                                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-upload mb-2 text-muted" width="32" height="32" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                                    <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path>
                                                                    <path d="M7 9l5 -5l5 5"></path>
                                                                    <path d="M12 4l0 12"></path>
                                                                </svg>
                                                                <div>{isUploadDragActive ? 'Drop the file here...' : 'Drag & drop a file here, or click to select'}</div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="modal-footer">
                                                    <button
                                                        type="button"
                                                        className="btn btn-link"
                                                        onClick={() => setShowUploadModal(false)}
                                                        disabled={uploadingFile}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </Modal>
                                            {/* Files Table */}
                                            <GenericView
                                                data={files}
                                                columns={fileColumns}
                                                onEdit={undefined}
                                                onDelete={handleDeleteFile}
                                                additionalActions={(file) => (
                                                    <div className="d-flex align-items-center">
                                                        <a
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                handleDownloadFile(file);
                                                            }}
                                                            title="Download file"
                                                        >
                                                            <ArrowDownToLine className="icon icon-tabler icon-tabler-download text-primary" />
                                                        </a>
                                                    </div>
                                                )}
                                                checkboxSelection={false}
                                                isLoading={loadingFiles}
                                                emptyStateMessage="No files uploaded yet"
                                                tableClassName="table card-table table-vcenter text-nowrap datatable table-hover"
                                                showTopControls={false}
                                                showPagination={true}
                                                initialPageSize={10}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card">
                                <div className="card-body">
                                    <h2 className="card-title">Info</h2>
                                    <div className='mb-3'>
                                        <div className='datagrid-title'>Client</div>
                                        <div className='datagrid-content'>
                                            {companyId ? (
                                                <a
                                                    href={`/clients/${companyId}`}
                                                    className="text-primary text-decoration-none"
                                                    onClick={(e) => {
                                                        // Allow right-click, Ctrl+Click, Cmd+Click to open in new tab
                                                        if (e.ctrlKey || e.metaKey || e.button === 1) {
                                                            return; // Let browser handle it
                                                        }
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        navigate(`/clients/${companyId}`);
                                                    }}
                                                    onAuxClick={(e) => {
                                                        // Handle middle mouse button click
                                                        if (e.button === 1) {
                                                            return; // Let browser handle it
                                                        }
                                                    }}
                                                    title={`View client details for ${proposalData.client.name}`}
                                                    aria-label={`View client details for ${proposalData.client.name}`}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                            e.preventDefault();
                                                            navigate(`/clients/${companyId}`);
                                                        }
                                                    }}
                                                >
                                                    {proposalData.client.name}
                                                </a>
                                            ) : (
                                                <span>{proposalData.client.name}</span>
                                            )}
                                        </div>
                                    </div>
                                    <div className='mb-3'>
                                        <div className='datagrid-title'>Sector</div>
                                        <div className='datagrid-content'>{leadSector || 'Not specified'}</div>
                                    </div>
                                    <div className='mb-3'>
                                        <div className='datagrid-title'>Status Approval</div>
                                        <div className={getStatusBadge(proposalData.statusApproval || proposalData.statusDesc || 'Draft')}>
                                            {proposalData.statusApproval || proposalData.statusDesc || 'Draft'}
                                        </div>
                                        {/* ✅ TAMBAHAN: Approval Tracking Status below Status Approval */}
                                        {approvalStatus && approvalStatus.length > 0 && (
                                            <div className='mt-2'>
                                                {approvalStatus.map((approval, index) => (
                                                    <div key={index}>
                                                        <small className='text-muted fst-italic'>
                                                            {approval.role === 'ROLE_MANAGER' ? 'Manager' :
                                                                approval.role === 'ROLE_DIRECTOR' ? 'Director' :
                                                                    approval.role}: {approval.status === 'approved' ? 'Approved' :
                                                                        approval.status === 'rejected' ? 'Rejected' : 'Pending'}
                                                        </small>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    <div className='mb-3'>
                                        <div className='datagrid-title'>Status Proposal</div>
                                        <div className={getProposalStatusBadge(proposalData.statusProposalDesc || 'Draft')}>
                                            {proposalData.statusProposalDesc || 'Draft'}
                                        </div>
                                    </div>
                                    <div className='mb-3'>
                                        <div className='datagrid-title'>Project Status</div>
                                        <div className={getProjectStatusBadge(projectStatus)}>
                                            {projectStatus}
                                        </div>
                                    </div>
                                    <div className='mb-3'>
                                        <div className='datagrid-title'>Services</div>
                                        <div>
                                            {(() => {
                                                const allStandards = proposalData.proposal_sections?.flatMap(section =>
                                                    section.services?.map(service => service.standard) || []
                                                ) || [];
                                                const uniqueStandards = [...new Set(allStandards)];
                                                return uniqueStandards.map((standard, index) => (
                                                    <div key={`standard-${index}-${standard}`} className='badge bg-primary text-white me-2 mb-1'>
                                                        {standard}
                                                    </div>
                                                ));
                                            })()}
                                        </div>
                                    </div>
                                    <div className='mb-3'>
                                        <div className='datagrid-title'>Proposal Template</div>
                                        <div className='datagrid-content'>{proposalData.template?.name || 'Template'}</div>
                                    </div>
                                    <div className='mb-3'>
                                        <div className='datagrid-title'>Proposal Date</div>
                                        <div className='datagrid-content'>{proposalData.dates.proposal_date}</div>
                                    </div>
                                    <div className='mb-3'>
                                        <div className='datagrid-title'>Valid Until</div>
                                        <div className='datagrid-content'>{proposalData.dates.valid_until}</div>
                                    </div>
                                    <div className='mb-3'>
                                        <div className='datagrid-title'>Assigned To</div>
                                        <div className='datagrid-content'>{proposalData.assigned_to?.name || 'Assigned To'}</div>
                                    </div>
                                    <div className='mb-3'>
                                        <div className='datagrid-title'>Teams</div>
                                        <div className='datagrid-content'>{proposalData.assigned_to.team}</div>
                                    </div>
                                    <div className='mb-3'>
                                        <div className='datagrid-title'>Contact</div>
                                        <div className='datagrid-content'>{leadData?.pic || 'Not specified'}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="card mt-3">
                                <div className="card-body">
                                    <h2 className="card-title">Proposal History</h2>
                                    <div
                                        style={{
                                            maxHeight: '400px',
                                            overflowY: 'auto',
                                            paddingRight: '8px'
                                        }}
                                    >
                                        <div className="position-relative" style={{ paddingLeft: '12px', paddingBottom: '1rem' }}>
                                            {/* Vertical connecting line - extends through all activities */}
                                            <div
                                                className="proposal-history-line"
                                                style={{
                                                    position: 'absolute',
                                                    left: '23px',
                                                    top: '12px',
                                                    bottom: '1rem',
                                                    width: '2px',
                                                    backgroundColor: '#e9ecef',
                                                    zIndex: 1
                                                }}
                                            />
                                            {proposalData.history?.map((activity, index, array) => (
                                                <div key={index} className="activity-item position-relative" style={{ marginBottom: index === array.length - 1 ? '0' : '1.5rem' }}>
                                                    <div className="row g-0">
                                                        <div className="col-auto position-relative">
                                                            <div className={`activity-icon bg-${getActivityColor(activity.type)} text-white rounded-circle d-flex align-items-center justify-content-center`}
                                                                style={{
                                                                    width: '24px',
                                                                    height: '24px',
                                                                    position: 'relative',
                                                                    zIndex: 2
                                                                }}>
                                                                {getActivityIcon(activity.type)}
                                                            </div>
                                                        </div>
                                                        <div className="col ms-3">
                                                            <div>
                                                                <div className="d-flex align-items-center justify-content-between mb-1">
                                                                    <div className={`activity-title text-${getActivityColor(activity.type, activity.notes)}`}>
                                                                        {getActivityTitle(activity.type, activity.notes)}
                                                                    </div>
                                                                    <div className="activity-time text-muted small">
                                                                        {formatActivityDate(activity.date)}
                                                                    </div>
                                                                </div>
                                                                <div className="activity-description text-muted">
                                                                    <span className="fw-bold">{activity.user}</span> {activity.notes}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )) || (
                                                    <div className="text-center text-muted py-3">No proposal history</div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const formatActivityDate = (dateString) => {
    if (!dateString) return '';

    try {
        const date = new Date(dateString);

        // Check if date is valid
        if (isNaN(date.getTime())) {
            return dateString; // Return original if invalid
        }

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${day}-${month}-${year} ${hours}:${minutes}`;
    } catch (error) {
        console.error('Error formatting date:', error);
        return dateString; // Return original if error
    }
};

const getActivityIcon = (type) => {
    switch (type) {
        case 'creation':
            return (
                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-plus" width="16" height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M12 5l0 14"></path>
                    <path d="M5 12l14 0"></path>
                </svg>
            );
        case 'sent':
            return (
                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-send" width="16" height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M10 14l11 -11"></path>
                    <path d="M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5"></path>
                </svg>
            );
        case 'status_change':
            return (
                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-refresh" width="16" height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"></path>
                    <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"></path>
                </svg>
            );
        case 'revision':
            return (
                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-edit" width="16" height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"></path>
                    <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z"></path>
                    <path d="M16 5l3 3"></path>
                </svg>
            );
        case 'approved':
            return (
                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-check" width="16" height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M5 12l5 5l10 -10"></path>
                </svg>
            );
        case 'rejected':
            return (
                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-x" width="16" height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M18 6l-12 12"></path>
                    <path d="M6 6l12 12"></path>
                </svg>
            );
        case 'converted':
            return (
                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-arrow-right" width="16" height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M5 12l14 0"></path>
                    <path d="M13 18l6 -6l-6 -6"></path>
                    <path d="M19 12l-6 -6"></path>
                </svg>
            );
        default:
            return null;
    }
};
const getActivityTitle = (type, notes = '') => {
    switch (type) {
        case 'creation':
            return 'Proposal Created';
        case 'sent':
            return 'Proposal Sent';
        case 'status_change':
            return 'Status Changed';
        case 'revision':
            // "Revision Requested" is for:
            // 1. Status approval = Revision (notes contain "requested revisions")
            // 2. Status proposal = Feedback (notes contain "provided feedback")
            // Otherwise, it's a regular update
            if (notes) {
                const notesLower = notes.toLowerCase();
                // Check for revision request (status approval = Revision)
                if (notesLower.includes('requested revisions')) {
                    return 'Revision Requested';
                }
                // Check for client feedback (status proposal = Feedback)
                if (notesLower.includes('provided feedback')) {
                    return 'Revision Requested';
                }
                // Regular update
                if (notesLower.includes('updated proposal details')) {
                    return 'Proposal Updated';
                }
            }
            // Default to "Revision Requested" for backward compatibility
            return 'Revision Requested';
        case 'approved':
            // Distinguish between internal approval and client accepted
            if (notes && notes.includes('The client')) {
                return 'Proposal Accepted';
            }
            return 'Proposal Approved';
        case 'rejected':
            return 'Proposal Rejected';
        case 'converted':
            return 'Converted to Project';
        default:
            return 'Activity';
    }
};
const getActivityColor = (type, notes = '') => {
    switch (type) {
        case 'creation':
            return 'primary';
        case 'sent':
            return 'info';
        case 'status_change':
            return 'warning';
        case 'revision':
            return 'warning';
        case 'approved':
            // Both use success color
            return 'success';
        case 'rejected':
            return 'danger';
        case 'converted':
            return 'info';
        default:
            return 'secondary';
    }
};
export default DetailProposal; 
